import React, { useEffect, useRef, useState } from 'react';

import AOS from 'aos'; // AOS 스크립트 파일을 임포트
// import '../../assets/scss/hostingMain.scss';
import { Swiper, SwiperSlide } from 'swiper/react';

import heroImage from '../../assets/imgs/hostingHero.webp';
import hostingIntroImage from '../../assets/imgs/hostingIntroImg.png';
import hostingIntroImage2 from '../../assets/imgs/hostingIntroImg2.png';
import hostingIntroBackground from '../../assets/imgs/hostingIntroBackground.png';
import productBanner from '../../assets/imgs/productBanner.jpg';
import bannerImg from '../../assets/imgs/bannerImg.jpg';
import BlackArrowBtn from '../../components/global/BlackArrowBtn';
import SectionTitle from '../../components/global/SectionTitle';
import portfolioImg1 from '../../assets/imgs/hosService1.jpg';
import portfolioImg2 from '../../assets/imgs/hosService2.jpg';
import portfolioImg3 from '../../assets/imgs/hosService3.jpg';
import { Link } from 'react-router-dom';
import useSwiperProgress from '../hook/useSwiperProgress';

const productData = [
  {
    cateCode: 'dell',
    name: 'R630',
    caption: 'Dell',
    spec: {
      cpu: '6 Core Xeon E5-2620V3 [2.4GHz] x 2',
      ram: 'DDR4 RDIMM 32GB',
      disk: 'SSD 250GB X 1 + SSD 250GB(백업용)',
    },
    price: '125,000',
  },
  {
    cateCode: 'supermicro',
    name: 'SS 5019-MT',
    caption: 'Supermicro',
    spec: {
      cpu: 'Intel Xeon E3-1230v6 (3.5GHz, 4Core/8Thread)',
      ram: '8GB',
      disk: 'SDD 240GB',
    },
    price: '90,000',
  },
];
const qnaData = [
  {
    q: '서버호스팅은 어떤 서비스인가요?',
    a: '서버호스팅은 고객이 직접 장비를 구입하지 않고, IDC에서 제공하는 물리 서버(단독 서버) 를 임대해 사용하는 서비스입니다. 자유로운 서버 환경 설정이 가능하며, 안정적인 인프라와 기술지원을 함께 제공합니다.',
  },
  {
    q: '클라우드 서비스와 무엇이 다른가요?',
    a: '서버호스팅은 단독 물리 서버를 사용하는 구조이며, 클라우드는 가상화된 서버(VM)를 공유하는 방식입니다. 호스팅은 고정된 성능과 보안이 강점이며, 클라우드는 유연한 확장성과 자동화가 장점입니다.',
  },
  {
    q: '운영체제(OS)나 프로그램 설치는 직접 해야 하나요?',
    a: '기본적으로 고객이 직접 설치할 수 있으며, 디엔에이클라우드에서는 초기 세팅, OS 설치, 보안 패치 등을 대행하는 매니지드 서비스 옵션도 제공합니다.',
  },
  {
    q: '트래픽이나 IP 주소는 추가할 수 있나요?',
    a: '네, 가능합니다. 기본 제공 외에도 트래픽 용량 업그레이드, 고정 IP 추가, 포트 변경 등의 구성이 자유롭게 가능합니다. 필요 시 상담을 통해 맞춤 견적도 제공됩니다.',
  },
];
function HostingMain({ firstSectionRef }) {
  const [activeProductTab, setActiveProductTab] = useState('all');
  const productSwiper = useRef(null);
  const [productActiveIndex, setProductActiveIndex] = useState(0);
  const [perGroup, setPerGroup] = useState(3); // Swiper의 slidesPerGroup 값
  const [activeFaqTab, setActiveFaqTab] = useState(0);
  const [portfolioActiveIndex, setPortfolioActiveIndex] = useState(1);
  const {
    progressPercent,
    tooltipPercent,
    tooltipVisible,
    handleMouseMove,
    handleMouseLeave,
    handleClick,
  } = useSwiperProgress(productSwiper, productActiveIndex, perGroup);

  useEffect(() => {
    if (productSwiper.current) {
      setPerGroup(productSwiper.current.params.slidesPerGroup || 1);
    }
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // 애니메이션 지속 시간 (ms)
      easing: 'ease-out', // 애니메이션 이징 함수
      once: false, // 스크롤 후 한 번만 애니메이션 실행
    });
  }, []);
  return (
    <div className="hostingPageWrapper">
      <div
        data-aos="fade"
        data-aos-delay="0"
        data-aos-offset="0"
        ref={firstSectionRef}
        className="subHeroSection"
      >
        <div className="heroItem flex-col align-center justify-center">
          <div className="subHeroImage">
            <img src={heroImage} alt="" />
          </div>
          <div className="grid flex-col justify-center align-center">
            <div className="flex-col gap-48 justify-center align-center">
              <div className="mainText">
                <span>서버호스팅</span>
              </div>
              <div className="description">
                <span>
                  <strong>내 서버처럼 직접 운영하는 독립 환경</strong>
                  <br />
                  저렴한 가격, 빠른 속도, 검증된 안정성까지
                  <br />
                  <strong>디엔에이클라우드라면</strong> 다릅니다.
                </span>
              </div>
              <div className="divide"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="serviceIntroSection py-128 flex-col align-center justify-center"
      >
        <div className="grid tab:flex-col flex-row gap-16 justify-between">
          <SectionTitle
            title={'서버호스팅이란?'}
            titleCaption={'SEVER HOSTING'}
            background={hostingIntroBackground}
            description={
              <>
                인터넷 비즈니스에 필요한{' '}
                <strong>
                  서버, 스토리지, 네트워크 장비를 <br />
                  디엔에이클라우드에서 임대 + 설치 + 관리까지
                </strong>
                한 번에 제공하는 서비스입니다.
                <br />
                물리 서버 단독 사용으로 성능 간섭 없이 운영 가능 기술지원, 보안,
                <br />
                네트워크까지 완비된 IDC 기반 인프라 <br />
                비용은 낮게, 품질은 높게 —{' '}
                <strong>중소기업부터 엔터프라이즈까지 최적화</strong>
                가능
              </>
            }
          />
          <div className="imgWrap ">
            <div className="layerOne">
              <img src={hostingIntroImage} alt="" />
            </div>
            <div className="layerTwo">
              <img src={hostingIntroImage2} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="ourStrongSection py-96 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-48">
          <SectionTitle
            title={'디엔에이클라우드만의 장점'}
            titleCaption={'FEATURES & BENEFITS'}
          />
          <div className="cardWrap tab:flex-col flex-row gap-16">
            <div className="card flex-col flex-full align-end gap-56 py-40 px-24">
              <div className="textWrap  flex-col gap-24">
                <div className="numberWrap">
                  <span>01</span>
                </div>
                <div className="titleWrap">
                  <span>
                    단독 서버로
                    <br />
                    안정적인 성능 제공
                  </span>
                </div>
                <div className="descriptionWrap">
                  <span>
                    서버 자원을 100% 독립 사용하여 다른 사용자로 인한 간섭 없이
                    안정적인 서비스 운영이 가능합니다.
                  </span>
                </div>
              </div>
              <div className="iconWrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="118"
                  height="110"
                  viewBox="0 0 118 110"
                  fill="none"
                >
                  <path
                    d="M97.485 55.1885L65.9465 73.4088V36.9702L97.485 18.7498V55.1885Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M65.9465 36.9698L34.4082 18.7495L65.9445 0.529076L97.4829 18.7495L65.9465 36.9698Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M65.9465 73.4088L34.4082 55.1885V18.7498L65.9465 36.9702V73.4088Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M54.5852 53.722L45.7634 48.6271V38.4351L54.5852 43.5301V53.722Z"
                    fill="white"
                  />
                  <path
                    d="M54.5852 53.722L45.7634 48.6271V44.4502C46.0556 44.1229 46.3395 43.7956 46.6234 43.4642C49.2856 43.773 51.9416 44.1127 54.5852 44.4812V53.722Z"
                    fill="white"
                  />
                  <path
                    d="M63.0767 79.3054L31.5383 97.5258V61.087L63.0767 42.8667V79.3054Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M31.5384 61.0861L0 42.8657L31.5384 24.6453L63.0768 42.8677L31.5384 61.0861Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M31.5381 48.7639L21.3298 42.8682L31.5381 36.9684L41.7465 42.8682L31.5381 48.7639Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M31.5384 97.5249L0 79.3045V42.8658L31.5384 61.0862V97.5249Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M20.1807 77.839L11.3569 72.742V62.5521L20.1807 67.6491V77.839Z"
                    fill="white"
                  />
                  <path
                    d="M117.666 91.6283L86.1274 109.849V73.41L117.666 55.1896V91.6283Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M86.1274 73.4098L54.5891 55.1894L86.1254 36.969L117.664 55.1894L86.1274 73.4098Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M86.1274 109.849L54.5891 91.6283V55.1896L86.1274 73.41V109.849Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M74.7661 90.1619L65.9443 85.0669V74.8749L74.7661 79.9699V90.1619Z"
                    fill="white"
                  />
                  <path
                    d="M74.7661 90.1619L65.9443 85.0669V80.8901C66.2365 80.5628 66.5204 80.2354 66.8043 79.904C69.4665 80.2128 72.1225 80.5525 74.7661 80.921V90.1619Z"
                    fill="white"
                  />
                  <circle
                    cx="29.4299"
                    cy="17.6501"
                    r="14.8886"
                    fill="#FC6A16"
                  />
                  <path
                    d="M22.8176 13.621H25.7563C26.146 13.621 26.5197 13.7758 26.7953 14.0513C27.0709 14.3269 27.2257 14.7006 27.2257 15.0903V16.5597C27.2257 16.9494 27.0709 17.3231 26.7953 17.5986C26.5197 17.8742 26.146 18.029 25.7563 18.029H24.287C23.8973 18.029 23.5235 18.1838 23.248 18.4594C22.9724 18.7349 22.8176 19.1087 22.8176 19.4984V20.9677C22.8176 21.3574 22.9724 21.7311 23.248 22.0067C23.5235 22.2822 23.8973 22.437 24.287 22.437H27.2257"
                    stroke="white"
                    stroke-width="2.93869"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M31.6335 13.621V16.5597C31.6335 16.9494 31.7883 17.3231 32.0639 17.5986C32.3395 17.8742 32.7132 18.029 33.1029 18.029H34.5722"
                    stroke="white"
                    stroke-width="2.93869"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M36.0417 13.621V22.437"
                    stroke="white"
                    stroke-width="2.93869"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div className="card flex-col flex-full align-end gap-56 py-40 px-24">
              <div className="textWrap flex-col gap-24">
                <div className="numberWrap">
                  <span>02</span>
                </div>
                <div className="titleWrap">
                  <span>
                    유연한 확장성 및
                    <br />
                    맞춤형 구성
                  </span>
                </div>
                <div className="descriptionWrap">
                  <span>
                    비즈니스 성장에 따라 서버 사양, 트래픽, 스토리지 등 자유롭게
                    확장 및 업그레이드할 수 있어 장기 운영에 최적입니다.
                  </span>
                </div>
              </div>
              <div className="iconWrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="150"
                  height="111"
                  viewBox="0 0 150 111"
                  fill="none"
                >
                  <path
                    d="M80.2353 47.0269L41.7861 24.814C41.3397 24.5565 40.8856 24.5162 40.4833 24.6543L40.4852 24.6504L40.4149 24.6766L40.3983 24.683L39.0086 25.2154L40.2559 25.8263L40.238 25.894L33.444 56.8088C33.131 58.2371 33.7588 59.9031 34.8465 60.5319L72.3714 82.2099L72.2373 83.8018L73.7554 83.2126C74.2657 82.9735 74.6745 82.4335 74.8437 81.6648L81.6371 50.7493C81.9513 49.3223 81.3229 47.655 80.2353 47.0269Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M80.2516 46.6272L41.8024 24.4144C41.356 24.1569 40.9019 24.1166 40.4996 24.2546L40.5015 24.2508L40.4312 24.277L40.4146 24.2834L39.0249 24.8157L40.2722 25.4267L40.2543 25.4944L35.5959 46.6834L54.4089 61.3503L81.4663 48.1603C81.2115 47.4995 80.788 46.9365 80.2516 46.6272Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M78.8022 51.012L81.7292 49.7652C81.7829 48.6309 81.3135 47.4588 80.5432 46.8326L75.9104 48.783L78.8022 51.012Z"
                    fill="#2E4B8D"
                  />
                  <path
                    d="M70.918 83.2502L32.4683 61.0374C31.3807 60.4098 30.7529 58.7432 31.0658 57.3149L37.8598 26.4001C38.1734 24.9731 39.3096 24.3244 40.3972 24.9533L78.8464 47.1655C79.934 47.7943 80.5618 49.4609 80.2482 50.8886L73.4542 81.804C73.1412 83.231 72.0057 83.879 70.918 83.2502Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M79.2171 47.0309L40.7679 24.8187C40.241 24.5139 39.7046 24.5145 39.2537 24.7523C39.6151 24.6737 40.0092 24.7286 40.3988 24.9536L78.8479 47.1657C79.9356 47.7946 80.5634 49.4612 80.2498 50.8889L73.4557 81.8037C73.2942 82.5398 72.9129 83.0626 72.4332 83.3163C73.0821 83.1744 73.6237 82.5852 73.8255 81.6688L80.6189 50.754C80.9325 49.3257 80.3047 47.6591 79.2171 47.0309Z"
                    fill="white"
                  />
                  <path
                    d="M70.0846 81.1286L33.9238 60.2482C32.9281 59.6737 32.3539 58.1483 32.6407 56.842L38.9027 28.3493C39.1895 27.043 40.2292 26.45 41.2243 27.0251L77.3857 47.9055C78.3807 48.4801 78.9555 50.0055 78.6688 51.3123L72.4067 79.8045C72.12 81.1113 71.0803 81.7037 70.0846 81.1286Z"
                    fill="white"
                  />
                  <path
                    d="M70.0846 81.1286L33.9238 60.2482C32.9281 59.6737 32.3539 58.1483 32.6407 56.842L38.9027 28.3493C39.1895 27.043 40.2292 26.45 41.2243 27.0251L77.3857 47.9055C78.3807 48.4801 78.9555 50.0055 78.6688 51.3123L72.4067 79.8045C72.12 81.1113 71.0803 81.7037 70.0846 81.1286Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M70.4001 81.001L34.2386 60.1206C33.2436 59.5448 32.6694 58.02 32.9556 56.7138L39.2182 28.221C39.3632 27.5603 39.7017 27.0842 40.129 26.8471C39.5555 26.9947 39.0822 27.5328 38.9027 28.3495L32.6407 56.8423C32.3539 58.1485 32.9281 59.6739 33.9238 60.2484L70.0846 81.1288C70.5764 81.4132 71.0783 81.41 71.4947 81.1787C71.1518 81.2675 70.7724 81.2164 70.4001 81.001Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M71.4496 84.2177L66.1934 83.5237L32.266 63.9233C31.1784 63.2951 29.279 63.3744 28.0228 64.099L3.98177 77.9831L0.804443 77.5632V79.3673L0.806993 79.3679C0.785917 79.7846 1.0235 80.1853 1.53698 80.4818L39.9861 102.695C41.0738 103.323 42.9738 103.244 44.23 102.519L70.4111 87.3983C71.1175 86.9905 71.47 86.4646 71.4496 85.9706V84.2177Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M45.9576 71.8327L43.5473 70.4403H17.0462L3.98177 77.983L0.804443 77.5631V79.3672L0.806993 79.3678C0.785917 79.7845 1.0235 80.1852 1.53698 80.4817L39.9861 102.694C40.5616 103.027 41.3624 103.16 42.1767 103.105L45.9576 71.8327Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M2.2146 77.7498L0.804443 77.5639V79.3679L0.806993 79.3685C0.785917 79.7852 1.0235 80.1859 1.53698 80.4824L2.2146 80.8741V77.7498Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M40.374 102.875C41.4048 103.267 42.8788 103.181 43.9792 102.652V98.6269H40.374V102.875Z"
                    fill="#2E4B8D"
                  />
                  <path
                    d="M39.9865 100.892L1.53737 78.6796C0.449733 78.0508 0.585768 76.9536 1.84201 76.2276L28.0232 61.1076C29.2794 60.3823 31.1788 60.3037 32.2664 60.9312L70.7162 83.1441C71.8038 83.7729 71.6678 84.8701 70.4115 85.5961L44.2304 100.715C42.9741 101.441 41.0741 101.52 39.9865 100.892Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M70.4106 84.9374L44.2295 100.057C42.9732 100.783 41.0732 100.862 39.9856 100.234L1.53645 78.0216C1.17944 77.8151 0.957185 77.5583 0.860109 77.2809C0.690226 77.796 0.907375 78.3168 1.53645 78.6804L39.9856 100.893C41.0732 101.521 42.9732 101.442 44.2295 100.717L70.4106 85.5969C71.2549 85.1087 71.5902 84.4536 71.3916 83.8849C71.2677 84.26 70.9401 84.6319 70.4106 84.9374Z"
                    fill="white"
                  />
                  <path
                    d="M17.8894 71.3263L16.1497 70.3217C16.0099 70.2411 16.0271 70.0999 16.1887 70.0066L18.242 68.8205C18.4035 68.7272 18.6475 68.717 18.7874 68.7975L20.5271 69.8028C20.667 69.8833 20.6491 70.0245 20.4881 70.1178L18.4342 71.3039C18.2733 71.3966 18.0293 71.4074 17.8894 71.3263Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M20.5777 72.8789L18.838 71.8743C18.6981 71.7931 18.716 71.6525 18.8769 71.5586L20.9302 70.3732C21.0918 70.2792 21.3358 70.2696 21.4756 70.3502L23.2147 71.3554C23.3546 71.4359 23.3373 71.5771 23.1757 71.6698L21.1225 72.8565C20.9609 72.9492 20.7169 72.96 20.5777 72.8789Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M23.263 74.43L21.5233 73.4255C21.3835 73.3449 21.4014 73.2044 21.5617 73.1104L23.6156 71.925C23.7765 71.831 24.0205 71.8214 24.1604 71.9013L25.9001 72.9072C26.0399 72.9877 26.0227 73.1283 25.8611 73.2216L23.8078 74.4077C23.6462 74.501 23.4023 74.5112 23.263 74.43Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M26.9794 73.1486L25.239 72.144C25.0998 72.0635 25.117 71.9229 25.2786 71.8296L27.0024 70.8333C27.1633 70.7406 27.4073 70.7298 27.5471 70.8109L29.2868 71.8162C29.4267 71.8967 29.4095 72.0373 29.2479 72.1312L27.5235 73.1262C27.3632 73.2202 27.1186 73.2298 26.9794 73.1486Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M29.6657 74.7001L27.926 73.6955C27.7868 73.615 27.8041 73.4738 27.9656 73.3811L29.6887 72.3848C29.8503 72.2921 30.0943 72.2813 30.2342 72.3625L31.9732 73.367C32.1131 73.4476 32.0958 73.5888 31.9349 73.6821L30.2112 74.6777C30.0496 74.7717 29.8056 74.7813 29.6657 74.7001Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M32.3517 76.2523L30.6113 75.2477C30.4721 75.1672 30.4894 75.026 30.6509 74.9333L32.3747 73.937C32.5356 73.8444 32.7802 73.8335 32.9201 73.9147L34.6592 74.9193C34.799 74.9998 34.7818 75.141 34.6202 75.2343L32.8965 76.23C32.7355 76.3233 32.4916 76.3335 32.3517 76.2523Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M35.0381 77.8046L33.2984 76.7993C33.1591 76.7188 33.1764 76.5782 33.338 76.4849L35.0611 75.4893C35.2226 75.396 35.4666 75.3857 35.6065 75.4669L37.3462 76.4715C37.486 76.552 37.4682 76.6926 37.3072 76.7866L35.5835 77.7822C35.4219 77.8755 35.1779 77.8857 35.0381 77.8046Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M37.7251 79.357L35.9854 78.3524C35.8462 78.2719 35.8634 78.1306 36.0244 78.038L37.7481 77.0417C37.9097 76.949 38.1537 76.9381 38.2935 77.0193L40.0326 78.0245C40.1725 78.1044 40.1552 78.2457 39.9936 78.3396L38.2705 79.3346C38.109 79.4285 37.865 79.4381 37.7251 79.357Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M40.4126 80.9089L38.6729 79.9043C38.533 79.8238 38.5503 79.6826 38.7119 79.5899L40.4356 78.5937C40.5966 78.501 40.8405 78.4901 40.9804 78.5713L42.7201 79.5759C42.86 79.6564 42.8427 79.7976 42.6811 79.8909L40.9574 80.8866C40.7965 80.9799 40.5518 80.9901 40.4126 80.9089Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M43.0988 82.4607L41.3597 81.4561C41.2199 81.3756 41.2371 81.2343 41.3981 81.141L43.1218 80.1454C43.2834 80.0521 43.5273 80.0419 43.6672 80.123L45.4063 81.1276C45.5461 81.2081 45.5289 81.3494 45.368 81.4427L43.6442 82.4383C43.4826 82.5316 43.2387 82.5419 43.0988 82.4607Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M45.7847 84.0137L44.045 83.0085C43.9051 82.928 43.9224 82.7874 44.0839 82.6941L45.8077 81.6984C45.9686 81.6051 46.2132 81.5943 46.3531 81.6754L48.0928 82.6807C48.232 82.7612 48.2148 82.9018 48.0532 82.9957L46.3295 83.9907C46.1685 84.0847 45.9246 84.0949 45.7847 84.0137Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M48.4711 85.5645L46.732 84.5599C46.5921 84.4794 46.6094 84.3381 46.771 84.2455L48.4941 83.2492C48.6556 83.1565 48.8996 83.1457 49.0395 83.2268L50.7798 84.2314C50.919 84.3119 50.9012 84.4532 50.7402 84.5471L49.0165 85.5421C48.8549 85.6361 48.6109 85.6456 48.4711 85.5645Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M51.1581 87.1173L49.4191 86.1127C49.2792 86.0322 49.2964 85.891 49.4574 85.7983L51.1811 84.802C51.3427 84.7087 51.5867 84.6985 51.7265 84.7796L53.4662 85.7843C53.6055 85.8648 53.5882 86.006 53.4266 86.0993L51.7035 87.0949C51.542 87.1882 51.298 87.1985 51.1581 87.1173Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M30.9352 72.4144L29.1961 71.4098C29.0562 71.3287 29.0735 71.1874 29.2351 71.0948L30.9588 70.0985C31.1197 70.0058 31.3637 69.9956 31.5036 70.0761L33.2433 71.0814C33.3831 71.1619 33.3659 71.3031 33.2043 71.3964L31.4806 72.3921C31.3196 72.4847 31.075 72.4949 30.9352 72.4144Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M28.2111 70.838L26.4707 69.8334C26.3309 69.7523 26.3488 69.6117 26.5103 69.5184L28.2341 68.5221C28.395 68.4294 28.6396 68.4192 28.7788 68.4997L30.5185 69.505C30.6584 69.5855 30.6405 69.7267 30.479 69.82L28.7552 70.8157C28.5943 70.909 28.3503 70.9186 28.2111 70.838Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M25.4795 69.2611L21.7325 67.096C21.5926 67.0155 21.6105 66.8742 21.7721 66.7816L23.4958 65.7853C23.6567 65.6926 23.9007 65.6824 24.0399 65.7629L27.7876 67.9274C27.9268 68.0086 27.9096 68.1492 27.748 68.2425L26.0242 69.2375C25.8633 69.3314 25.6193 69.341 25.4795 69.2611Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M27.3874 67.3426L24.3467 65.5858C24.2069 65.5053 24.2241 65.3641 24.3857 65.2714L26.1101 64.2751C26.271 64.1818 26.515 64.1722 26.6542 64.2528L29.6955 66.0095C29.8354 66.09 29.8175 66.2306 29.6559 66.3239L27.9322 67.3196C27.7712 67.4129 27.5266 67.4231 27.3874 67.3426Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M33.6239 73.9658L31.8849 72.9612C31.745 72.8801 31.7623 72.7388 31.9232 72.6462L33.6469 71.6499C33.8085 71.5566 34.0525 71.547 34.1924 71.6275L35.9321 72.6327C36.0713 72.7133 36.054 72.8545 35.8931 72.9472L34.1694 73.9434C34.0078 74.0361 33.7638 74.0463 33.6239 73.9658Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M36.3115 75.5181L34.5718 74.5129C34.432 74.4317 34.4492 74.2911 34.6108 74.1978L36.3345 73.2015C36.4955 73.1089 36.7401 73.0993 36.88 73.1792L38.6197 74.1851C38.7589 74.2656 38.7416 74.4062 38.5801 74.4995L36.8563 75.4951C36.6954 75.5884 36.4514 75.5986 36.3115 75.5181Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M38.9962 77.0705L37.2571 76.0659C37.1173 75.9847 37.1345 75.8435 37.2961 75.7508L39.0192 74.7545C39.1808 74.6619 39.4247 74.6516 39.5646 74.7322L41.305 75.7374C41.4442 75.8179 41.4263 75.9591 41.2654 76.0524L39.5416 77.0481C39.38 77.1414 39.1361 77.151 38.9962 77.0705Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M41.685 78.6219L39.9459 77.6173C39.8061 77.5362 39.8233 77.3949 39.9842 77.3023L41.708 76.306C41.8696 76.2127 42.1135 76.2031 42.2534 76.2836L43.9931 77.2889C44.1323 77.3694 44.1151 77.5106 43.9535 77.6033L42.2304 78.5996C42.0688 78.6922 41.8249 78.7025 41.685 78.6219Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M44.3685 80.1746L42.6295 79.1693C42.4896 79.0888 42.5068 78.9476 42.6684 78.8543L44.3928 77.8586C44.5531 77.7653 44.7971 77.7557 44.9369 77.8363L46.6773 78.8415C46.8165 78.922 46.7993 79.0626 46.6377 79.1559L44.9139 80.1522C44.753 80.2448 44.5084 80.2551 44.3685 80.1746Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M47.0571 81.7266L45.318 80.722C45.1781 80.6408 45.1954 80.5002 45.3563 80.4069L47.0807 79.4107C47.2423 79.318 47.4856 79.3078 47.6255 79.3883L49.3652 80.3942C49.5044 80.474 49.4872 80.6153 49.3262 80.7086L47.6025 81.7042C47.4409 81.7975 47.1969 81.8071 47.0571 81.7266Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M49.7429 83.2783L48.0032 82.2737C47.8634 82.1926 47.8806 82.0514 48.0422 81.9587L49.7666 80.9624C49.9275 80.8697 50.1715 80.8595 50.3113 80.94L52.051 81.9453C52.1909 82.0258 52.173 82.167 52.0115 82.2597L50.2877 83.256C50.1268 83.3493 49.8828 83.3589 49.7429 83.2783Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M52.4299 84.8312L50.6902 83.8266C50.5504 83.7454 50.5676 83.6042 50.7292 83.5109L52.4529 82.5152C52.6145 82.4219 52.8579 82.4124 52.9977 82.4929L54.7381 83.4981C54.8779 83.5786 54.8594 83.7199 54.6985 83.8125L52.9747 84.8088C52.8131 84.9015 52.5692 84.9117 52.4299 84.8312Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M55.1168 86.3821L53.3771 85.3769C53.2372 85.2957 53.2551 85.1551 53.4154 85.0618L55.1398 84.0662C55.3014 83.9729 55.5447 83.9627 55.6846 84.0432L57.4243 85.0491C57.5642 85.1296 57.5463 85.2702 57.3847 85.3635L55.6616 86.3591C55.5 86.4524 55.256 86.4626 55.1168 86.3821Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M59.8948 89.1418L56.0992 86.9486C55.9594 86.8681 55.9766 86.7275 56.1376 86.6342L57.8613 85.6385C58.0229 85.5452 58.2668 85.535 58.4067 85.6155L62.2023 87.8088C62.3421 87.8893 62.3249 88.0305 62.1633 88.1232L60.4402 89.1195C60.2786 89.2121 60.0347 89.223 59.8948 89.1418Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M65.1234 86.1192L61.9193 84.2691C61.7794 84.1879 61.7973 84.0467 61.9582 83.9541L63.6826 82.9584C63.8436 82.8651 64.0875 82.8549 64.2274 82.9354L67.4309 84.7867C67.5708 84.8666 67.5529 85.0078 67.3919 85.1018L65.6682 86.0968C65.5066 86.1907 65.2626 86.2003 65.1234 86.1192Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M38.3279 73.6623L36.5882 72.6577C36.4483 72.5771 36.4656 72.4359 36.6272 72.3433L38.3515 71.347C38.5125 71.2543 38.7564 71.2435 38.8963 71.3246L40.636 72.3292C40.7752 72.4097 40.758 72.5509 40.5964 72.6442L38.8727 73.6399C38.7117 73.7338 38.4678 73.7434 38.3279 73.6623Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M35.5757 72.0722L33.836 71.067C33.6968 70.9864 33.714 70.8452 33.875 70.7519L35.5987 69.7563C35.7603 69.6636 36.0043 69.6527 36.1441 69.7339L37.8832 70.7385C38.0231 70.8196 38.0058 70.9602 37.8442 71.0535L36.1205 72.0492C35.9589 72.1425 35.7156 72.1527 35.5757 72.0722Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M32.8224 70.4813L31.0833 69.4761C30.9434 69.3949 30.9607 69.2543 31.1223 69.161L32.846 68.1654C33.007 68.0721 33.2509 68.0625 33.3908 68.143L35.1305 69.1476C35.2697 69.2288 35.2525 69.37 35.0915 69.4627L33.3678 70.4589C33.2062 70.5516 32.9622 70.5618 32.8224 70.4813Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M30.0693 68.8904L28.3296 67.8846C28.1898 67.8041 28.2076 67.6635 28.3692 67.5702L30.093 66.5739C30.2539 66.4812 30.4979 66.471 30.6377 66.5515L32.3774 67.5574C32.5173 67.6373 32.5001 67.7785 32.3385 67.8718L30.6141 68.8674C30.4532 68.9607 30.2092 68.9703 30.0693 68.8904Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M41.016 75.2139L39.2769 74.2093C39.137 74.1288 39.1543 73.9875 39.3159 73.8942L41.0396 72.8986C41.2012 72.8059 41.4445 72.7951 41.5844 72.8762L43.3247 73.8808C43.464 73.9613 43.4461 74.1026 43.2851 74.1959L41.5614 75.1915C41.3998 75.2848 41.1559 75.295 41.016 75.2139Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M43.7021 76.7664L41.9617 75.7611C41.8225 75.6806 41.8398 75.54 42.0007 75.4467L43.7251 74.4511C43.8867 74.3578 44.13 74.3475 44.2699 74.4287L46.0096 75.4333C46.1494 75.5138 46.1315 75.6544 45.97 75.7484L44.2469 76.744C44.0853 76.8373 43.8413 76.8475 43.7021 76.7664Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M46.3887 78.3172L44.649 77.3126C44.5091 77.2321 44.527 77.0908 44.688 76.9982L46.4123 76.0019C46.5733 75.9092 46.8166 75.8984 46.9565 75.9795L48.6968 76.9847C48.8367 77.0646 48.8188 77.2059 48.6572 77.2998L46.9335 78.2948C46.7726 78.3887 46.528 78.3983 46.3887 78.3172Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M49.074 79.8704L47.3343 78.8658C47.1945 78.7853 47.2123 78.644 47.3733 78.5514L49.097 77.5551C49.2586 77.4624 49.5019 77.4515 49.6418 77.5327L51.3815 78.5373C51.5214 78.6178 51.5035 78.759 51.3425 78.8523L49.6188 79.848C49.4572 79.9413 49.2132 79.9515 49.074 79.8704Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M51.7633 81.4223L50.023 80.4177C49.8831 80.3372 49.901 80.196 50.0626 80.1027L51.7863 79.1071C51.9473 79.0137 52.1919 79.0035 52.3311 79.0847L54.0708 80.0893C54.2107 80.1698 54.1928 80.311 54.0312 80.4043L52.3075 81.4C52.1465 81.4926 51.9025 81.5035 51.7633 81.4223Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M54.4495 82.9741L52.7098 81.9689C52.5699 81.8884 52.5878 81.7478 52.7493 81.6545L54.4725 80.6589C54.634 80.5656 54.878 80.5547 55.0172 80.6359L56.7576 81.6411C56.8968 81.7216 56.8789 81.8622 56.718 81.9561L54.9942 82.9512C54.8327 83.0445 54.5887 83.0553 54.4495 82.9741Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M57.1352 84.527L55.3948 83.5224C55.2556 83.4419 55.2735 83.3006 55.4344 83.2073L57.1582 82.2117C57.3197 82.119 57.5637 82.1082 57.7029 82.1893L59.4426 83.1939C59.5825 83.2744 59.5646 83.4157 59.403 83.5096L57.6799 84.5046C57.5184 84.5979 57.2744 84.6081 57.1352 84.527Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M59.8218 86.0781L58.0821 85.0735C57.9422 84.993 57.9601 84.8518 58.1217 84.7585L59.8454 83.7628C60.0063 83.6695 60.2503 83.6593 60.3895 83.7404L62.1299 84.745C62.2697 84.8256 62.2519 84.9668 62.0909 85.0594L60.3665 86.0557C60.2056 86.1484 59.9616 86.1593 59.8218 86.0781Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M62.5071 87.6307L60.7674 86.6255C60.6276 86.545 60.6454 86.4044 60.8064 86.3104L62.5301 85.3154C62.6917 85.2221 62.9357 85.2119 63.0749 85.2931L64.8146 86.2976C64.9545 86.3782 64.9366 86.5188 64.7763 86.6121L63.0519 87.6083C62.8903 87.701 62.647 87.7119 62.5071 87.6307Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M36.9136 69.8232L35.1739 68.8187C35.0341 68.7375 35.0519 68.5963 35.2129 68.5036L36.9373 67.508C37.0982 67.4147 37.3422 67.4044 37.4814 67.4849L39.2217 68.4902C39.3616 68.5713 39.3437 68.7119 39.1821 68.8052L37.4584 69.8009C37.2975 69.8942 37.0529 69.9044 36.9136 69.8232Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M34.2397 68.2788L32.5 67.2736C32.3608 67.1931 32.378 67.0519 32.5396 66.9586L34.2627 65.9635C34.4243 65.8702 34.6683 65.8594 34.8081 65.9406L36.5478 66.9458C36.6871 67.0257 36.6698 67.1669 36.5089 67.2608L34.7851 68.2558C34.6236 68.3491 34.3796 68.36 34.2397 68.2788Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M31.5682 66.7351L29.8285 65.7292C29.6886 65.6487 29.7059 65.5081 29.8668 65.4148L31.5912 64.4185C31.7528 64.3258 31.9961 64.3156 32.136 64.3961L33.8757 65.4007C34.0155 65.4819 33.9977 65.6231 33.8367 65.7164L32.113 66.712C31.9514 66.8053 31.7074 66.8149 31.5682 66.7351Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M28.8941 65.1899L27.1544 64.1854C27.0151 64.1042 27.0324 63.9642 27.1933 63.8703L28.9171 62.8747C29.0786 62.7814 29.3226 62.7711 29.4625 62.8516L31.2015 63.8569C31.3414 63.938 31.3242 64.0786 31.1626 64.1719L29.4389 65.1676C29.2779 65.2609 29.0339 65.2711 28.8941 65.1899Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M31.6426 63.6018L29.9029 62.5972C29.763 62.5167 29.7809 62.3755 29.9425 62.2828L30.5115 61.9531C30.6731 61.8598 30.9171 61.8502 31.0569 61.9307L32.7966 62.9353C32.9359 63.0165 32.9186 63.1571 32.7577 63.2504L32.1873 63.5795C32.0264 63.6734 31.7818 63.683 31.6426 63.6018Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M35.1313 65.6181L33.391 64.6122C33.2517 64.5317 33.2696 64.3911 33.4299 64.2978L34.0002 63.9681C34.1612 63.8754 34.4058 63.8652 34.5457 63.9457L36.2847 64.9516C36.4246 65.0315 36.4074 65.1727 36.2458 65.266L35.6761 65.5951C35.5145 65.6884 35.2705 65.698 35.1313 65.6181Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M37.7952 67.1559L36.0555 66.1506C35.9156 66.0701 35.9329 65.9295 36.0944 65.8356L36.6641 65.5071C36.8257 65.4132 37.0697 65.4036 37.2095 65.4847L38.9486 66.4893C39.0885 66.5699 39.0712 66.7105 38.9103 66.8038L38.34 67.1335C38.1784 67.2262 37.9344 67.2364 37.7952 67.1559Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M40.4556 68.6938L38.7159 67.6893C38.576 67.6087 38.5933 67.4675 38.7548 67.3748L39.3245 67.0451C39.4861 66.9518 39.7301 66.9422 39.8699 67.0227L41.6096 68.0273C41.7495 68.1085 41.7316 68.2491 41.5707 68.3424L41.0004 68.6715C40.8394 68.7648 40.5948 68.775 40.4556 68.6938Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M43.1175 70.2313L41.3778 69.2261C41.2379 69.1456 41.2558 69.0044 41.4167 68.9117L41.9871 68.5819C42.148 68.4886 42.3926 68.4791 42.5318 68.5596L44.2715 69.5648C44.4114 69.6453 44.3935 69.7866 44.2326 69.8792L43.6629 70.209C43.5013 70.3023 43.2573 70.3119 43.1175 70.2313Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M57.981 78.8179L56.2413 77.8121C56.1021 77.7315 56.1193 77.5909 56.2802 77.4976L56.8499 77.1685C57.0115 77.0752 57.2555 77.0656 57.3953 77.1455L59.135 78.1507C59.2743 78.2319 59.257 78.3725 59.0954 78.4658L58.5258 78.7949C58.3648 78.8882 58.1209 78.8984 57.981 78.8179Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M60.6416 80.3555L58.9019 79.3509C58.7626 79.2697 58.7799 79.1285 58.9415 79.0358L59.5105 78.7067C59.6721 78.6128 59.9161 78.6032 60.0559 78.6837L61.7963 79.6889C61.9349 79.7694 61.9176 79.9107 61.7567 80.0033L61.1863 80.3331C61.0254 80.4258 60.7814 80.436 60.6416 80.3555Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M63.3041 81.8931L61.5637 80.8885C61.4245 80.808 61.4418 80.6667 61.6033 80.5734L62.173 80.2443C62.334 80.1516 62.5786 80.1408 62.7178 80.2219L64.4581 81.2265C64.5974 81.3071 64.5801 81.4483 64.4185 81.5416L63.8482 81.8707C63.6873 81.964 63.4439 81.9742 63.3041 81.8931Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M65.9676 83.4311L64.2279 82.4259C64.088 82.3454 64.1059 82.2041 64.2668 82.1115L64.8365 81.7817C64.9981 81.689 65.2421 81.6788 65.3819 81.7594L67.121 82.7639C67.2609 82.8451 67.2436 82.9863 67.082 83.0796L66.5123 83.4081C66.3508 83.502 66.1074 83.5116 65.9676 83.4311Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M39.6006 71.3755L37.8609 70.3709C37.7211 70.2897 37.7389 70.1485 37.8999 70.0558L39.6236 69.0595C39.7852 68.9669 40.0292 68.9567 40.1684 69.0372L41.9081 70.0424C42.048 70.1229 42.0301 70.2642 41.8692 70.3575L40.1454 71.3531C39.9838 71.4458 39.7399 71.456 39.6006 71.3755Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M42.2865 72.9272L40.5462 71.9226C40.4063 71.8415 40.4242 71.7003 40.5858 71.6076L42.3095 70.6113C42.4705 70.518 42.7151 70.5084 42.8543 70.5889L44.594 71.5942C44.7339 71.6747 44.716 71.8159 44.5544 71.9086L42.8307 72.9049C42.6697 72.9975 42.4257 73.0077 42.2865 72.9272Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M44.9729 74.4806L43.2332 73.4754C43.0933 73.3942 43.1112 73.2536 43.2728 73.1603L44.9959 72.164C45.1575 72.0714 45.4014 72.0618 45.5407 72.1417L47.2804 73.1475C47.4202 73.2281 47.4023 73.3686 47.2414 73.4619L45.5177 74.4582C45.3561 74.5509 45.1121 74.5605 44.9729 74.4806Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M47.662 76.031L45.9217 75.0264C45.7818 74.9453 45.8004 74.804 45.9613 74.7114L47.685 73.7151C47.8466 73.6224 48.0906 73.6122 48.2298 73.6927L49.9695 74.698C50.1094 74.7785 50.0915 74.9197 49.9305 75.013L48.2068 76.0087C48.0452 76.102 47.8019 76.1115 47.662 76.031Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M50.3469 77.5839L48.6072 76.5793C48.4673 76.4981 48.4852 76.3569 48.6468 76.2642L50.3705 75.2679C50.5315 75.1746 50.7754 75.165 50.9147 75.2456L52.655 76.2508C52.7949 76.3313 52.777 76.4725 52.6161 76.5652L50.8917 77.5615C50.7308 77.6541 50.4868 77.6644 50.3469 77.5839Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M53.034 79.1361L51.2943 78.1309C51.1544 78.0503 51.1723 77.9091 51.3332 77.8158L53.057 76.8202C53.2186 76.7269 53.4625 76.7173 53.6017 76.7978L55.3415 77.803C55.4813 77.8835 55.4641 78.0241 55.3031 78.1174L53.5787 79.1137C53.4172 79.2064 53.1739 79.2166 53.034 79.1361Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M55.7196 80.6876L53.9793 79.683C53.84 79.6019 53.8573 79.4613 54.0189 79.368L55.7426 78.3717C55.9035 78.2791 56.1482 78.2688 56.288 78.3493L58.0271 79.3552C58.167 79.4351 58.1497 79.5763 57.9881 79.6696L56.2637 80.6653C56.1028 80.7586 55.8595 80.7682 55.7196 80.6876Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M58.406 82.2402L56.6663 81.2357C56.527 81.1545 56.5443 81.0133 56.7059 80.9206L58.429 79.9243C58.5906 79.8317 58.8345 79.8214 58.9744 79.902L60.7135 80.9072C60.8533 80.9877 60.8361 81.1289 60.6751 81.2216L58.9508 82.2179C58.7898 82.3112 58.5458 82.3208 58.406 82.2402Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M61.0949 83.7916L59.3545 82.787C59.2153 82.7059 59.2332 82.5646 59.3941 82.4713L61.1179 81.4757C61.2794 81.3824 61.5234 81.3728 61.6633 81.4533L63.4023 82.4586C63.5422 82.5391 63.525 82.6803 63.3634 82.773L61.6397 83.7693C61.4787 83.8619 61.2348 83.8721 61.0949 83.7916Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M24.2404 71.5672L19.1165 68.6072C18.9772 68.5266 18.9945 68.3854 19.1561 68.2927L20.8792 67.2965C21.0407 67.2038 21.2847 67.1936 21.4246 67.2741L26.5479 70.2342C26.6878 70.3147 26.6705 70.4559 26.5089 70.5486L24.7852 71.5449C24.6236 71.6375 24.3803 71.6478 24.2404 71.5672Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M57.2464 90.6343L52.1224 87.6742C51.9825 87.5936 52.0004 87.4524 52.1614 87.3597L53.8851 86.3635C54.0467 86.2708 54.2906 86.2606 54.4299 86.3411L59.5538 89.3012C59.6937 89.3817 59.6758 89.5229 59.5142 89.6156L57.7905 90.6119C57.6296 90.7045 57.3856 90.7154 57.2464 90.6343Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M46.5012 87.8556L44.7621 86.851C44.6222 86.7699 44.6395 86.6286 44.8004 86.536L46.8543 85.3492C47.0153 85.2566 47.2599 85.2464 47.3997 85.3269L49.1388 86.3315C49.2787 86.4126 49.2614 86.5539 49.0999 86.6472L47.0466 87.8332C46.885 87.9265 46.641 87.9361 46.5012 87.8556Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M26.9922 76.5856L24.2102 74.9784C24.0704 74.8979 24.0883 74.7567 24.2498 74.6634L26.3025 73.4773C26.4641 73.384 26.708 73.3738 26.8479 73.4543L29.6299 75.0621C29.7698 75.1427 29.7525 75.2832 29.5909 75.3765L27.5376 76.5626C27.3761 76.6566 27.1321 76.6668 26.9922 76.5856Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M43.9148 86.3602L41.1322 84.753C40.9923 84.6725 41.0102 84.5313 41.1711 84.4386L43.2244 83.2519C43.3854 83.1592 43.63 83.1484 43.7692 83.2295L46.5512 84.8367C46.6911 84.9179 46.6738 85.0578 46.5129 85.1518L44.4589 86.3379C44.298 86.4312 44.0534 86.4408 43.9148 86.3602Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M30.8679 78.8243L28.0852 77.2171C27.946 77.1366 27.9632 76.9953 28.1248 76.9027L30.1781 75.7159C30.3397 75.6226 30.583 75.6124 30.7229 75.6936L33.5055 77.3008C33.6447 77.3813 33.6275 77.5219 33.4659 77.6158L31.4126 78.8013C31.251 78.8952 31.0077 78.9048 30.8679 78.8243Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M30.7436 75.7043L42.8398 82.6923C42.9899 82.7792 42.9899 82.9198 42.8398 83.0061L40.7463 84.2158C40.5955 84.3027 40.3522 84.3027 40.2021 84.2158L28.106 77.2278L30.7436 75.7043Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M54.0115 90.6698L55.9492 91.7895C56.0641 91.8553 56.0501 91.9709 55.9172 92.0476L55.0774 92.5327C54.9452 92.6094 54.7453 92.617 54.631 92.5512L52.6933 91.4316C52.5783 91.3651 52.5924 91.2501 52.7246 91.174L53.5651 90.6884C53.6973 90.6123 53.8965 90.6034 54.0115 90.6698Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M51.3032 89.1056L53.2409 90.2246C53.3552 90.2911 53.3405 90.4067 53.2083 90.4834L52.3685 90.9685C52.2369 91.0451 52.0364 91.0528 51.922 90.987L49.9837 89.8674C49.87 89.8009 49.8841 89.6859 50.0163 89.6092L50.8561 89.1242C50.9883 89.0481 51.1882 89.0398 51.3032 89.1056Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M48.6146 87.5536L50.5523 88.6726C50.6673 88.7384 50.6526 88.8547 50.5204 88.9308L49.6805 89.4164C49.5483 89.4925 49.3478 89.5001 49.2341 89.4343L47.2958 88.3147C47.1815 88.2489 47.1955 88.1332 47.3277 88.0572L48.1682 87.5715C48.3004 87.4954 48.5003 87.4871 48.6146 87.5536Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M52.7851 88.2488L54.7234 89.3678C54.8378 89.4342 54.8237 89.5499 54.6915 89.6266L53.851 90.1116C53.7188 90.1883 53.5196 90.196 53.4046 90.1302L51.4669 89.0106C51.352 88.9441 51.366 88.8291 51.4989 88.753L52.3387 88.2673C52.4709 88.1913 52.6708 88.1823 52.7851 88.2488Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M47.3858 41.3898L43.0161 38.8655L43.2026 37.9242L47.5723 40.4484L47.3858 41.3898Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M46.9112 43.5771L42.5415 41.0529L42.7274 40.1116L47.097 42.6358L46.9112 43.5771Z"
                    fill="white"
                  />
                  <path
                    d="M68.359 73.9218L63.9893 71.3969L64.1751 70.4562L68.5448 72.9804L68.359 73.9218Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M45.962 47.9528L41.5923 45.4285L41.7788 44.4872L46.1485 47.0114L45.962 47.9528Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M54.2016 53.0623L49.7968 50.5182C49.4066 50.2926 49.1747 49.7348 49.2776 49.2721L50.2355 44.9655C50.3384 44.5022 50.7382 44.3092 51.1284 44.5348L55.5332 47.0795C55.9228 47.3044 56.1553 47.863 56.0518 48.3256L55.0938 52.6316C54.991 53.0949 54.5912 53.2879 54.2016 53.0623Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M61.8842 57.5011L57.4794 54.9557C57.0891 54.7308 56.8567 54.1729 56.9601 53.7096L57.9181 49.4037C58.021 48.9403 58.4208 48.7473 58.811 48.9729L63.2152 51.517C63.606 51.7426 63.8378 52.3005 63.735 52.7631L62.777 57.0697C62.6736 57.5324 62.2744 57.7254 61.8842 57.5011Z"
                    fill="#BCE5F8"
                  />
                  <path
                    d="M52.4987 60.7112L48.0945 58.1672C47.7043 57.9416 47.4718 57.3837 47.5746 56.9204L48.5333 52.6144C48.6361 52.1511 49.0359 51.9588 49.4255 52.1831L53.8303 54.7284C54.2199 54.9534 54.453 55.5113 54.3495 55.9746L53.3909 60.2805C53.288 60.7438 52.8889 60.9368 52.4987 60.7112Z"
                    fill="white"
                  />
                  <path
                    d="M60.183 65.1504L55.7788 62.6057C55.3886 62.3801 55.1561 61.8222 55.259 61.3596L56.2176 57.053C56.3204 56.5903 56.7202 56.3973 57.1104 56.6229L61.5146 59.167C61.9048 59.3919 62.1373 59.9505 62.0345 60.4131L61.0759 64.7203C60.973 65.183 60.5732 65.376 60.183 65.1504Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M114.53 98.5653V96.1906H113.825C113.191 95.0991 112.136 94.0716 110.632 93.2015C105.434 90.1991 97.0059 90.1991 91.8081 93.2015C90.3036 94.0716 89.2489 95.0991 88.6155 96.1906H87.9109V98.5442H87.9116C87.9026 100.519 89.2002 102.496 91.8089 104.002C97.0059 107.006 105.434 107.006 110.632 104.002C113.231 102.501 114.53 100.533 114.53 98.5653Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M110.632 93.2009C105.975 90.5112 98.7334 90.239 93.5371 92.3691V104.834C98.7334 106.964 105.975 106.693 110.632 104.002C113.232 102.5 114.531 100.532 114.531 98.5648V96.19H113.825C113.191 95.0986 112.136 94.0711 110.632 93.2009Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M110.631 101.627C105.434 104.631 97.0052 104.63 91.8082 101.627C86.6096 98.6242 86.6096 93.7564 91.8074 90.7529C97.0052 87.7506 105.433 87.7506 110.631 90.7529C115.829 93.7564 115.829 98.6251 110.631 101.627Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M110.632 101.627C105.435 104.63 97.0066 104.63 91.8096 101.627C89.3186 100.188 88.0346 98.3199 87.9311 96.4341C87.8187 98.4827 89.1027 100.552 91.8096 102.116C97.0066 105.119 105.435 105.119 110.632 102.116C113.34 100.552 114.623 98.4827 114.511 96.4341C114.407 98.3199 113.123 100.188 110.632 101.627Z"
                    fill="white"
                  />
                  <path
                    d="M109.749 96.3516C109.189 96.6771 108.341 96.7161 107.854 96.4371L99.7421 91.7896C99.524 91.6645 99.416 91.4972 99.4123 91.3208L99.4041 74.6371L110.193 79.1744L110.207 95.6894V95.787C110.183 95.9841 110.029 96.189 109.749 96.3516Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M110.193 79.1744L110.207 95.6894V95.787C110.183 95.9842 110.029 96.189 109.748 96.3516C109.482 96.5078 109.149 96.5968 108.82 96.6179L108.776 78.5782L110.193 79.1744Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M146.994 46.1718L67.9957 0.534523C67.2696 0.115234 66.6063 0.0882339 66.0954 0.37851L66.0948 0.375511L63.627 1.80739L65.1329 2.01967C65.0963 2.24319 65.0764 2.4847 65.0764 2.74348V57.3231C65.0764 59.4751 66.3838 61.9728 67.9957 62.9052L146.873 108.473L146.47 110.105L148.902 108.698L148.899 108.695C149.519 108.34 149.913 107.513 149.913 106.334V51.7539C149.913 49.6027 148.606 47.1034 146.994 46.1718Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M144.489 109.994L65.4923 64.357C63.8795 63.4254 62.573 60.9269 62.573 58.7757V4.19454C62.573 2.04409 63.8795 1.0555 65.4923 1.98708L144.489 47.6244C146.103 48.556 147.409 51.0545 147.409 53.2057V107.786C147.409 109.937 146.103 110.926 144.489 109.994Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M144.879 47.4999L65.8806 1.86184C65.1949 1.46581 64.5653 1.4193 64.0667 1.66006C64.4877 1.58956 64.9729 1.68857 65.4906 1.9871L144.488 47.6244C146.101 48.556 147.407 51.0545 147.407 53.2057V107.786C147.407 109.021 146.976 109.871 146.303 110.196C147.194 110.044 147.798 109.122 147.798 107.662V53.0804C147.798 50.93 146.491 48.4308 144.879 47.4999Z"
                    fill="white"
                  />
                  <path
                    d="M144.738 108.185L65.2457 62.2618C64.6753 61.9325 64.2126 61.0482 64.2126 60.2876V4.57681C64.2126 3.81549 64.6753 3.46596 65.2457 3.79524L144.738 49.7183C145.308 50.0476 145.771 50.932 145.771 51.6933V107.404C145.771 108.165 145.308 108.515 144.738 108.185Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M100.36 53.6444L95.1911 50.6584C94.7331 50.3936 94.3621 49.6848 94.3621 49.0735V43.3969C94.3621 42.7871 94.7331 42.5058 95.1911 42.7699L100.36 45.7566C100.818 46.0214 101.189 46.7302 101.189 47.3415V53.0181C101.189 53.6286 100.818 53.9092 100.36 53.6444Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M109.377 58.8545L104.208 55.8677C103.75 55.6029 103.379 54.8941 103.379 54.2843V48.6063C103.379 47.9965 103.75 47.7159 104.208 47.98L109.377 50.9667C109.835 51.2308 110.206 51.9403 110.206 52.5509V58.2274C110.206 58.8387 109.835 59.1193 109.377 58.8545Z"
                    fill="#BCE5F8"
                  />
                  <path
                    d="M100.36 63.7294L95.1911 60.7427C94.7331 60.478 94.3621 59.7691 94.3621 59.1593V53.4813C94.3621 52.8715 94.7331 52.591 95.1911 52.855L100.36 55.8418C100.818 56.1058 101.189 56.8153 101.189 57.4259V63.1024C101.189 63.713 100.818 63.9943 100.36 63.7294Z"
                    fill="white"
                  />
                  <path
                    d="M109.377 68.9386L104.208 65.9518C103.75 65.6877 103.379 64.9775 103.379 64.3675V58.6911C103.379 58.0798 103.75 57.7992 104.208 58.064L109.377 61.0508C109.835 61.3148 110.206 62.0244 110.206 62.6342V68.3115C110.206 68.9221 109.835 69.2025 109.377 68.9386Z"
                    fill="#4067B1"
                  />
                </svg>
              </div>
            </div>
            <div className="card flex-col flex-full align-end gap-56 py-40 px-24">
              <div className="textWrap flex-col gap-24">
                <div className="numberWrap">
                  <span>03</span>
                </div>
                <div className="titleWrap">
                  <span>
                    24시간 기술 지원 및
                    <br />
                    실시간 모니터링
                  </span>
                </div>
                <div className="descriptionWrap">
                  <span>
                    전문 엔지니어가 연중무휴로 대응하며, 실시간 모니터링을 통해
                    장애를 사전에 감지하고 빠르게 조치합니다.
                  </span>
                </div>
              </div>
              <div className="iconWrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="131"
                  height="95"
                  viewBox="0 0 131 95"
                  fill="none"
                >
                  <path
                    d="M102.408 76.0722L102.415 71.5524L107.758 44.618L102.482 41.3581L91.9103 47.1964L91.836 81.9108C91.8301 84.2472 92.7041 85.8272 94.0485 86.3412V86.343L98.7504 89.3L99.3403 87.0643L100.147 82.9925C101.508 80.9867 102.402 78.4202 102.408 76.0722Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M102.382 89.1954C99.4615 90.809 97.1019 89.0075 97.1106 85.1742L97.1864 50.4583L107.757 44.6181L107.683 79.334C107.674 83.1685 105.301 87.5849 102.382 89.1954Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M130.918 25.9267C130.918 34.7371 124.736 38.3085 117.11 33.9035C109.484 29.4976 103.303 18.7839 103.303 9.97357C103.303 1.1628 109.484 -2.40804 117.11 1.99662C124.736 6.40215 130.918 17.1152 130.918 25.9267Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M127.006 34.7892L86.8233 57.8464L65.2222 25.3765L107.084 1.18681L127.006 34.7892Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M111.204 37.6925C111.204 28.6316 104.844 17.6111 97.002 13.0798C93.4363 11.0205 90.1823 10.6607 87.6886 11.726L87.6843 11.7185L87.6333 11.7448L87.5692 11.7755L87.2458 11.9344C72.4164 19.2263 56.0036 22.7123 39.4874 22.0696L34.8088 21.8874L72.9029 87.2076L74.9668 83.2184C82.4915 68.6657 93.4873 56.2054 106.972 46.9287C109.583 45.461 111.204 42.2631 111.204 37.6925Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M77.346 72.4466C77.346 55.0634 65.1486 33.9242 50.1021 25.2316C42.5992 20.8974 35.8043 20.4772 30.8781 23.3005V23.2993L30.8519 23.3153L30.814 23.3369L26.3452 25.9576L27.9067 25.6313C24.7284 28.9437 22.8582 34.1644 22.8582 40.9697C22.8582 58.3529 35.0556 79.4921 50.1021 88.1847C56.0071 91.5966 61.4722 92.5833 65.9337 91.473L65.2273 92.5167L69.3421 90.1072L69.4062 90.0708L69.5548 89.9832H69.5489C74.3702 87.0915 77.346 81.0316 77.346 72.4466Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M74.1575 74.3069C74.1575 56.9235 61.9601 35.7843 46.9151 27.0919C39.5113 22.8145 32.7993 22.351 27.8892 25.0514L27.2061 25.451C26.9716 25.5996 26.7443 25.7568 26.52 25.9191L27.9067 25.6303C24.7284 28.9427 22.8582 34.1634 22.8582 40.9687C22.8582 58.352 35.0556 79.4911 50.1021 88.1837C56.0071 91.5957 61.4722 92.5824 65.9337 91.4721L65.2899 92.4224C70.739 89.8148 74.1575 83.5096 74.1575 74.3069Z"
                    fill="white"
                  />
                  <path
                    d="M73.2549 74.8399C73.2549 92.2233 61.0575 99.2704 46.011 90.5791C30.9659 81.8854 18.7686 60.7474 18.7686 43.363C18.7686 25.9778 30.9659 18.9324 46.011 27.6249C61.0575 36.3175 73.2549 57.4567 73.2549 74.8399Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M69.9137 72.9091C69.9137 88.1603 59.2122 94.3432 46.0112 86.7159C32.8101 79.0902 22.1101 60.5438 22.1101 45.2915C22.1101 30.0391 32.8101 23.8579 46.0112 31.4847C59.2122 39.1103 69.9137 57.6568 69.9137 72.9091Z"
                    fill="#263C7A"
                  />
                  <path
                    d="M47.1269 86.2393C33.9274 78.6137 23.2244 60.0655 23.2244 44.8144C23.2244 36.8055 26.1783 31.299 30.8919 28.979C25.5316 30.9466 22.1101 36.669 22.1101 45.2926C22.1101 60.5449 32.8101 79.0913 46.0112 86.717C52.2788 90.3402 57.9828 90.8446 62.2477 88.746C58.127 90.2587 52.8644 89.5523 47.1269 86.2393Z"
                    fill="white"
                  />
                  <mask
                    id="mask0_239_84"
                    style={{ 'mask-type': 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="22"
                    y="28"
                    width="48"
                    height="62"
                  >
                    <path
                      d="M69.912 72.9091C69.912 88.1603 59.2104 94.3432 46.0094 86.7159C32.8084 79.0902 22.1084 60.5438 22.1084 45.2915C22.1084 30.0391 32.8084 23.8579 46.0094 31.4847C59.2104 39.1103 69.912 57.6568 69.912 72.9091Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_239_84)">
                    <path
                      d="M42.4324 53.3829L77.1136 26.5521L89.7072 48.4143L49.0001 65.127L42.4324 53.3829Z"
                      fill="#D9EFFB"
                    />
                    <path
                      d="M50.7833 61.8576C50.7833 64.9034 48.6465 66.1384 46.01 64.6148C43.3736 63.0919 41.2368 59.3885 41.2368 56.3425C41.2368 53.2966 43.3736 52.0634 46.01 53.5864C48.6465 55.1093 50.7833 58.8128 50.7833 61.8576Z"
                      fill="#5F92D3"
                    />
                  </g>
                  <path
                    d="M18.7686 3.77673C20.3353 3.77673 21.7953 4.54285 22.6894 5.82244L22.8616 6.08492L36.1727 28.3104C36.5772 29.011 36.7973 29.8029 36.8123 30.6118C36.8274 31.4206 36.6369 32.2201 36.2588 32.9353C35.8806 33.6505 35.3271 34.258 34.6501 34.701C33.9731 35.1439 33.1948 35.4078 32.388 35.4679L32.0681 35.4811H5.45099C4.64338 35.472 3.85124 35.2584 3.1485 34.8603C2.44577 34.4622 1.85535 33.8925 1.43237 33.2045C1.00939 32.5165 0.767625 31.7325 0.729652 30.9257C0.69168 30.1189 0.858733 29.3157 1.21522 28.591L1.37763 28.2875L14.6821 6.07836C15.1081 5.37591 15.7079 4.7951 16.4237 4.39195C17.1395 3.9888 17.9471 3.77691 18.7686 3.77673ZM18.7686 19.0826H17.1281L16.9361 19.0941C16.5374 19.1415 16.1699 19.3335 15.9033 19.6338C15.6367 19.934 15.4894 20.3216 15.4894 20.7231C15.4894 21.1246 15.6367 21.5122 15.9033 21.8125C16.1699 22.1127 16.5374 22.3047 16.9361 22.3521L17.1281 22.3636V27.2851L17.1396 27.4771C17.1827 27.8432 17.348 28.1842 17.6088 28.4449C17.8695 28.7057 18.2105 28.8709 18.5766 28.9141L18.7686 28.9256H20.4091L20.601 28.9141C20.9672 28.8709 21.3082 28.7057 21.5689 28.4449C21.8296 28.1842 21.9949 27.8432 22.0381 27.4771L22.0496 27.2851L22.0381 27.0932C21.9989 26.7585 21.8575 26.444 21.6333 26.1924C21.409 25.9409 21.1128 25.7645 20.7848 25.6873L20.601 25.6545L20.4091 25.6446V20.7231L20.3976 20.5312C20.3544 20.165 20.1891 19.824 19.9284 19.5633C19.6677 19.3026 19.3267 19.1373 18.9605 19.0941L18.7686 19.0826ZM18.785 14.1611L18.5766 14.1726C18.1779 14.22 17.8104 14.412 17.5438 14.7123C17.2772 15.0125 17.1299 15.4001 17.1299 15.8016C17.1299 16.2031 17.2772 16.5907 17.5438 16.891C17.8104 17.1912 18.1779 17.3832 18.5766 17.4306L18.7686 17.4421L18.9769 17.4306C19.3756 17.3832 19.7431 17.1912 20.0098 16.891C20.2764 16.5907 20.4237 16.2031 20.4237 15.8016C20.4237 15.4001 20.2764 15.0125 20.0098 14.7123C19.7431 14.412 19.3756 14.22 18.9769 14.1726L18.785 14.1611Z"
                    fill="#FC6A16"
                  />
                </svg>
              </div>
            </div>
            <div className="card flex-col flex-full align-end gap-56 py-40 px-24">
              <div className="textWrap flex-col gap-24">
                <div className="numberWrap">
                  <span>04</span>
                </div>
                <div className="titleWrap">
                  <span>
                    합리적인 비용,
                    <br />
                    탄력적 요금제
                  </span>
                </div>
                <div className="descriptionWrap">
                  <span>
                    초기 비용 부담 없이 월 단위 요금제, 기본 구성부터 고성능
                    서버까지 원하는 스펙으로 효율적인 운영이 가능합니다.
                  </span>
                </div>
              </div>
              <div className="iconWrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="113"
                  height="109"
                  viewBox="0 0 113 109"
                  fill="none"
                >
                  <path
                    d="M9.1042 52.9435V43.1488L31.0531 43.1355L38.639 38.7544C40.3805 37.7472 43.4213 37.8739 45.4309 39.036L52.5099 43.1252L74.478 43.1136V53.1854C74.5267 53.866 74.148 54.5236 73.3112 55.0056L44.9432 71.3944C43.2033 72.401 40.1609 72.2744 38.1514 71.1128L10.7587 55.2889C9.59922 54.618 9.03938 53.7515 9.1042 52.9435Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M41.7918 38.0811C43.0648 38.1105 44.3863 38.4334 45.4309 39.0364L52.5099 43.1256L74.478 43.114V53.1858C74.5267 53.8664 74.148 54.5241 73.3112 55.006L44.9432 71.3948C44.1064 71.8797 42.969 72.098 41.7918 72.0687V38.0811Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M71.9926 43.1135H74.478V53.1854C74.5267 53.866 74.148 54.5236 73.3112 55.0055L71.9926 55.7692V43.1135Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M44.5051 71.6092C43.0039 72.2526 40.8322 72.2168 39.0761 71.5476V60.1094H44.5051V71.6092Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M44.9423 61.3569L73.3103 44.9698C75.0517 43.9632 74.8322 42.2075 72.8227 41.0442L45.43 25.2202C43.4204 24.0587 40.3796 23.9333 38.6382 24.9387L10.2702 41.3269C8.52874 42.3323 8.74827 44.0899 10.7578 45.2514L38.1505 61.0753C40.16 62.2357 43.2024 62.3624 44.9423 61.3569Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M10.7574 43.3234L38.1501 59.1486C40.1596 60.3107 43.202 60.4355 44.9419 59.4301L73.3099 43.0419C73.6989 42.8178 73.9832 42.5535 74.1791 42.2691C74.7773 43.2337 74.5062 44.2789 73.3099 44.9698L44.9419 61.3569C43.202 62.3624 40.1596 62.2357 38.1501 61.0753L10.7574 45.2514C9.19572 44.349 8.71985 43.0874 9.40051 42.0981C9.67454 42.5374 10.1268 42.9589 10.7574 43.3234Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M19.5372 55.527C19.5372 56.2583 20.0499 57.1476 20.6819 57.5132C21.3155 57.8789 21.8281 57.5823 21.8281 56.851C21.8281 56.1196 21.3155 55.2321 20.6819 54.8665C20.0499 54.4998 19.5372 54.7974 19.5372 55.527Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M15.8509 53.3963C15.8509 54.1288 16.3651 55.0179 16.9971 55.3819C17.6306 55.7475 18.1433 55.4527 18.1433 54.7219C18.1433 53.9906 17.6306 53.1003 16.9971 52.7347C16.3651 52.3689 15.8509 52.665 15.8509 53.3963Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M12.1644 51.2683C12.1644 51.9991 12.6785 52.8882 13.3106 53.2538C13.9426 53.6195 14.4568 53.3229 14.4568 52.5916C14.4568 51.8608 13.9426 50.9717 13.3106 50.6061C12.6785 50.2404 12.1644 50.537 12.1644 51.2683Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M43.2678 51.1989L56.5421 43.5303C57.3568 43.0597 57.2552 42.2368 56.3137 41.6933L43.4962 34.2883C42.5548 33.7442 41.1316 33.6854 40.3184 34.1571L27.0426 41.8257C26.2279 42.2962 26.3296 43.1185 27.271 43.6609L40.0885 51.0659C41.03 51.61 42.4531 51.6705 43.2678 51.1989Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M41.9924 44.7762L43.8281 43.715L43.7972 43.4616L42.0248 42.4371L41.5843 42.4192L39.7471 43.4806L39.7781 43.7338L41.5519 44.759L41.9924 44.7762Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M56.5421 43.529L56.5038 43.5508L56.3137 43.4196L43.4962 36.0134C42.5548 35.4693 41.1316 35.4105 40.3184 35.8822L27.0795 43.529C26.3296 42.9922 26.2898 42.2591 27.0426 41.8244L40.3184 34.1558C41.1316 33.684 42.5548 33.7429 43.4962 34.287L56.3137 41.692C57.2552 42.2355 57.3568 43.0584 56.5421 43.529Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M9.1042 40.9779V31.1832L31.0531 31.17L38.639 26.7888C40.3805 25.7816 43.4213 25.9083 45.4309 27.0704L52.5099 31.1596L74.478 31.148V41.2198C74.5267 41.9004 74.148 42.5581 73.3112 43.04L44.9432 59.4288C43.2033 60.4354 40.1609 60.3088 38.1514 59.1473L10.7587 43.3233C9.59922 42.6524 9.03938 41.7859 9.1042 40.9779Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M41.7918 26.1155C43.0648 26.1449 44.3863 26.4679 45.4309 27.0708L52.5099 31.1601L74.478 31.1484V41.2202C74.5267 41.9009 74.148 42.5585 73.3112 43.0404L44.9432 59.4293C44.1064 59.9141 42.969 60.1324 41.7918 60.1031V26.1155Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M71.9926 31.1481H74.478V41.2199C74.5267 41.9005 74.148 42.5582 73.3112 43.0401L71.9926 43.8037V31.1481Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M44.5051 59.6437C43.0039 60.287 40.8322 60.2512 39.0761 59.582V48.1438H44.5051V59.6437Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M44.9423 49.3913L73.3103 33.0042C75.0517 31.9977 74.8322 30.2419 72.8227 29.0786L45.43 13.2547C43.4204 12.0932 40.3796 11.9677 38.6382 12.9731L10.2702 29.3614C8.52874 30.3668 8.74827 32.1243 10.7578 33.2858L38.1505 49.1097C40.16 50.2701 43.2024 50.3969 44.9423 49.3913Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M10.7574 31.3579L38.1501 47.183C40.1596 48.3451 43.202 48.47 44.9419 47.4646L73.3099 31.0763C73.6989 30.8522 73.9832 30.5879 74.1791 30.3035C74.7773 31.2681 74.5062 32.3133 73.3099 33.0042L44.9419 49.3913C43.202 50.3969 40.1596 50.2701 38.1501 49.1097L10.7574 33.2858C9.19572 32.3835 8.71985 31.1218 9.40051 30.1325C9.67454 30.5718 10.1268 30.9933 10.7574 31.3579Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M19.5372 43.5606C19.5372 44.2919 20.0499 45.1811 20.6819 45.5467C21.3155 45.9125 21.8281 45.6159 21.8281 44.8845C21.8281 44.1532 21.3155 43.2657 20.6819 42.9001C20.0499 42.5333 19.5372 42.831 19.5372 43.5606Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M15.8509 41.4307C15.8509 42.1633 16.3651 43.0523 16.9971 43.4163C17.6306 43.7819 18.1433 43.4871 18.1433 42.7563C18.1433 42.025 17.6306 41.1347 16.9971 40.7691C16.3651 40.4034 15.8509 40.6994 15.8509 41.4307Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M12.1644 39.3027C12.1644 40.0335 12.6785 40.9226 13.3106 41.2882C13.9426 41.6539 14.4568 41.3573 14.4568 40.626C14.4568 39.8952 13.9426 39.0061 13.3106 38.6405C12.6785 38.2748 12.1644 38.5714 12.1644 39.3027Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M43.2678 39.2326L56.5421 31.564C57.3568 31.0934 57.2552 30.2705 56.3137 29.727L43.4962 22.322C42.5548 21.7779 41.1316 21.719 40.3184 22.1908L27.0426 29.8594C26.2279 30.3299 26.3296 31.1522 27.271 31.6946L40.0885 39.0996C41.03 39.6437 42.4531 39.7042 43.2678 39.2326Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M41.9924 32.8107L43.8281 31.7494L43.7972 31.496L42.0248 30.4716L41.5843 30.4536L39.7471 31.515L39.7781 31.7683L41.5519 32.7934L41.9924 32.8107Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M56.5421 31.5635L56.5038 31.5853L56.3137 31.4541L43.4962 24.0479C42.5548 23.5038 41.1316 23.445 40.3184 23.9167L27.0795 31.5635C26.3296 31.0268 26.2898 30.2936 27.0426 29.8589L40.3184 22.1903C41.1316 21.7186 42.5548 21.7774 43.4962 22.3215L56.3137 29.7265C57.2552 30.2701 57.3568 31.0929 56.5421 31.5635Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M9.1042 29.0125V19.2179L31.0531 19.2046L38.639 14.8235C40.3805 13.8163 43.4213 13.9429 45.4309 15.105L52.5099 19.1943L74.478 19.1827V29.2545C74.5267 29.9351 74.148 30.5927 73.3112 31.0746L44.9432 47.4635C43.2033 48.4701 40.1609 48.3434 38.1514 47.1819L10.7587 31.358C9.59922 30.6871 9.03938 29.8206 9.1042 29.0125Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M41.7918 14.1501C43.0648 14.1794 44.3863 14.5024 45.4309 15.1054L52.5099 19.1946L74.478 19.183V29.2548C74.5267 29.9354 74.148 30.593 73.3112 31.075L44.9432 47.4638C44.1064 47.9487 42.969 48.167 41.7918 48.1377V14.1501Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M71.9926 19.1826H74.478V29.2544C74.5267 29.9351 74.148 30.5927 73.3112 31.0746L71.9926 31.8383V19.1826Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M44.5051 47.6782C43.0039 48.3216 40.8322 48.2857 39.0761 47.6166V36.1784H44.5051V47.6782Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M44.9423 37.4259L73.3103 21.0388C75.0517 20.0322 74.8322 18.2764 72.8227 17.1132L45.43 1.28922C43.4204 0.127705 40.3796 0.00224686 38.6382 1.00764L10.2702 17.3959C8.52874 18.4013 8.74827 20.1588 10.7578 21.3204L38.1505 37.1443C40.16 38.3046 43.2024 38.4314 44.9423 37.4259Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M10.7574 19.3924L38.1501 35.2175C40.1596 36.3796 43.202 36.5045 44.9419 35.4991L73.3099 19.1108C73.6989 18.8868 73.9832 18.6224 74.1791 18.3381C74.7773 19.3026 74.5062 20.3478 73.3099 21.0388L44.9419 37.4259C43.202 38.4314 40.1596 38.3046 38.1501 37.1443L10.7574 21.3203C9.19572 20.418 8.71985 19.1564 9.40051 18.1671C9.67454 18.6064 10.1268 19.0278 10.7574 19.3924Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M19.5372 31.5961C19.5372 32.3274 20.0499 33.2167 20.6819 33.5823C21.3155 33.948 21.8281 33.6514 21.8281 32.92C21.8281 32.1887 21.3155 31.3012 20.6819 30.9356C20.0499 30.5689 19.5372 30.8665 19.5372 31.5961Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M15.8509 29.4654C15.8509 30.1979 16.3651 31.087 16.9971 31.451C17.6306 31.8166 18.1433 31.5218 18.1433 30.791C18.1433 30.0597 17.6306 29.1694 16.9971 28.8038C16.3651 28.438 15.8509 28.7341 15.8509 29.4654Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M12.1644 27.3374C12.1644 28.0682 12.6785 28.9573 13.3106 29.3229C13.9426 29.6886 14.4568 29.392 14.4568 28.6606C14.4568 27.9299 13.9426 27.0408 13.3106 26.6752C12.6785 26.3095 12.1644 26.6061 12.1644 27.3374Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M43.2678 27.268L56.5421 19.5994C57.3568 19.1288 57.2552 18.3059 56.3137 17.7624L43.4962 10.3574C42.5548 9.81326 41.1316 9.75444 40.3184 10.2262L27.0426 17.8948C26.2279 18.3653 26.3296 19.1876 27.271 19.73L40.0885 27.135C41.03 27.6791 42.4531 27.7396 43.2678 27.268Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M41.9924 20.8453L43.8281 19.7841L43.7972 19.5307L42.0248 18.5062L41.5843 18.4883L39.7471 19.5497L39.7781 19.8029L41.5519 20.8281L41.9924 20.8453Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M56.5421 19.5981L56.5038 19.6199L56.3137 19.4887L43.4962 12.0825C42.5548 11.5384 41.1316 11.4795 40.3184 11.9513L27.0795 19.5981C26.3296 19.0613 26.2898 18.3282 27.0426 17.8935L40.3184 10.2249C41.1316 9.75312 42.5548 9.81195 43.4962 10.3561L56.3137 17.7611C57.2552 18.3046 57.3568 19.1275 56.5421 19.5981Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M47.2812 74.1223V64.3276L69.2301 64.3144L76.816 59.9332C78.5575 58.926 81.5983 59.0527 83.6079 60.2148L90.6869 64.304L112.655 64.2924V74.3642C112.704 75.0448 112.325 75.7025 111.488 76.1844L83.1202 92.5732C81.3803 93.5798 78.3379 93.4532 76.3284 92.2917L48.9357 76.4677C47.7762 75.7968 47.2164 74.9303 47.2812 74.1223Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M79.9688 59.2591C81.2418 59.2884 82.5633 59.6114 83.6079 60.2144L90.687 64.3036L112.655 64.292V74.3638C112.704 75.0444 112.325 75.702 111.488 76.184L83.1202 92.5728C82.2834 93.0577 81.146 93.276 79.9688 93.2467V59.2591Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M110.17 64.2925H112.655V74.3643C112.704 75.0449 112.325 75.7026 111.488 76.1845L110.17 76.9481V64.2925Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M82.6819 92.7872C81.1806 93.4306 79.009 93.3947 77.2528 92.7256V81.2874H82.6819V92.7872Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M83.1193 82.5349L111.487 66.1478C113.229 65.1412 113.009 63.3855 111 62.2222L83.607 46.3982C81.5974 45.2367 78.5566 45.1113 76.8152 46.1166L48.4472 62.5049C46.7057 63.5103 46.9253 65.2678 48.9348 66.4294L76.3275 82.2533C78.3371 83.4136 81.3794 83.5404 83.1193 82.5349Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M48.9344 64.5014L76.3271 80.3265C78.3366 81.4886 81.379 81.6135 83.1189 80.6081L111.487 64.2198C111.876 63.9958 112.16 63.7314 112.356 63.4471C112.954 64.4116 112.683 65.4568 111.487 66.1478L83.1189 82.5349C81.379 83.5404 78.3366 83.4136 76.3271 82.2533L48.9344 66.4294C47.3727 65.527 46.8969 64.2654 47.5775 63.2761C47.8515 63.7154 48.3038 64.1368 48.9344 64.5014Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M57.7142 76.705C57.7142 77.4363 58.2269 78.3255 58.8589 78.6911C59.4925 79.0569 60.0051 78.7603 60.0051 78.0289C60.0051 77.2976 59.4925 76.4101 58.8589 76.0445C58.2269 75.6777 57.7142 75.9754 57.7142 76.705Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M54.0279 74.5743C54.0279 75.3068 54.5421 76.1959 55.1741 76.5599C55.8076 76.9255 56.3203 76.6306 56.3203 75.8999C56.3203 75.1685 55.8076 74.2783 55.1741 73.9127C54.5421 73.5469 54.0279 73.8429 54.0279 74.5743Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M50.3414 72.4463C50.3414 73.1771 50.8555 74.0661 51.4876 74.4317C52.1196 74.7975 52.6338 74.5009 52.6338 73.7695C52.6338 73.0388 52.1196 72.1497 51.4876 71.7841C50.8555 71.4183 50.3414 71.715 50.3414 72.4463Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M81.4431 72.377L94.7174 64.7084C95.5321 64.2378 95.4305 63.4149 94.489 62.8714L81.6715 55.4664C80.7301 54.9223 79.3069 54.8635 78.4937 55.3352L65.2179 63.0038C64.4032 63.4743 64.5049 64.2966 65.4463 64.839L78.2638 72.244C79.2052 72.7881 80.6284 72.8486 81.4431 72.377Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M80.1694 65.9542L82.0051 64.893L81.9742 64.6395L80.2018 63.6151L79.7613 63.5971L77.9241 64.6586L77.9551 64.9118L79.7289 65.937L80.1694 65.9542Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M94.7174 64.7071L94.6791 64.7289L94.489 64.5977L81.6715 57.1915C80.7301 56.6474 79.3069 56.5886 78.4937 57.0603L65.2548 64.7071C64.5049 64.1703 64.4651 63.4372 65.2179 63.0025L78.4937 55.3339C79.3069 54.8621 80.7301 54.921 81.6715 55.4651L94.489 62.8701C95.4305 63.4136 95.5321 64.2365 94.7174 64.7071Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M47.2827 62.1581V52.3634L69.2316 52.3501L76.8175 47.969C78.5589 46.9618 81.5998 47.0885 83.6093 48.2506L90.6884 52.3398L112.657 52.3282V62.4C112.705 63.0806 112.326 63.7382 111.49 64.2202L83.1217 80.609C81.3817 81.6156 78.3394 81.489 76.3298 80.3274L48.9372 64.5035C47.7777 63.8326 47.2178 62.9661 47.2827 62.1581Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M79.9703 47.2947C81.2432 47.3241 82.5648 47.6471 83.6093 48.25L90.6884 52.3393L112.657 52.3276V62.3994C112.705 63.0801 112.326 63.7377 111.49 64.2196L83.1217 80.6085C82.2848 81.0933 81.1475 81.3116 79.9703 81.2823V47.2947Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M110.171 52.3273H112.657V62.3991C112.705 63.0797 112.326 63.7374 111.49 64.2193L110.171 64.9829V52.3273Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M82.6836 80.8229C81.1823 81.4662 79.0107 81.4304 77.2545 80.7612V69.323H82.6836V80.8229Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M83.1208 70.5705L111.489 54.1834C113.23 53.1769 113.011 51.4211 111.001 50.2578L83.6085 34.4339C81.5989 33.2724 78.558 33.1469 76.8166 34.1523L48.4486 50.5406C46.7072 51.546 46.9267 53.3035 48.9363 54.465L76.329 70.2889C78.3385 71.4493 81.3809 71.5761 83.1208 70.5705Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M48.9359 52.5371L76.3285 68.3622C78.3381 69.5243 81.3804 69.6491 83.1204 68.6438L111.488 52.2555C111.877 52.0314 112.162 51.7671 112.358 51.4827C112.956 52.4473 112.685 53.4925 111.488 54.1834L83.1204 70.5705C81.3804 71.5761 78.3381 71.4493 76.3285 70.2889L48.9359 54.465C47.3742 53.5627 46.8983 52.301 47.579 51.3117C47.853 51.751 48.3053 52.1725 48.9359 52.5371Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M57.7157 64.7399C57.7157 65.4712 58.2284 66.3605 58.8604 66.7261C59.4939 67.0918 60.0066 66.7952 60.0066 66.0638C60.0066 65.3325 59.4939 64.445 58.8604 64.0794C58.2284 63.7127 57.7157 64.0103 57.7157 64.7399Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M54.0293 62.6101C54.0293 63.3426 54.5435 64.2317 55.1756 64.5956C55.8091 64.9612 56.3218 64.6664 56.3218 63.9356C56.3218 63.2043 55.8091 62.314 55.1756 61.9484C54.5435 61.5827 54.0293 61.8787 54.0293 62.6101Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M50.3428 60.4824C50.3428 61.2132 50.857 62.1023 51.489 62.4679C52.1211 62.8336 52.6353 62.537 52.6353 61.8057C52.6353 61.0749 52.1211 60.1858 51.489 59.8202C50.857 59.4545 50.3428 59.7511 50.3428 60.4824Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M81.4463 60.4126L94.7206 52.744C95.5353 52.2735 95.4336 51.4506 94.4922 50.907L81.6747 43.502C80.7332 42.9579 79.3101 42.8991 78.4968 43.3708L65.2211 51.0394C64.4064 51.51 64.508 52.3323 65.4495 52.8746L78.267 60.2796C79.2084 60.8238 80.6316 60.8842 81.4463 60.4126Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M80.1709 53.99L82.0066 52.9287L81.9757 52.6753L80.2033 51.6509L79.7628 51.6329L77.9256 52.6943L77.9565 52.9476L79.7304 53.9727L80.1709 53.99Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M94.7206 52.7427L94.6823 52.7645L94.4922 52.6333L81.6747 45.2271C80.7332 44.683 79.3101 44.6242 78.4968 45.0959L65.2579 52.7427C64.508 52.206 64.4683 51.4728 65.2211 51.0381L78.4968 43.3695C79.3101 42.8978 80.7332 42.9566 81.6747 43.5007L94.4922 50.9057C95.4336 51.4493 95.5353 52.2721 94.7206 52.7427Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M47.2827 50.191V40.3964L69.2316 40.3831L76.8175 36.0019C78.5589 34.9948 81.5998 35.1214 83.6093 36.2835L90.6884 40.3728L112.657 40.3611V50.4329C112.705 51.1136 112.326 51.7712 111.49 52.2531L83.1217 68.642C81.3817 69.6485 78.3394 69.5219 76.3298 68.3604L48.9372 52.5365C47.7777 51.8655 47.2178 50.999 47.2827 50.191Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M79.9703 35.3286C81.2432 35.3579 82.5648 35.6809 83.6093 36.2838L90.6884 40.3731L112.657 40.3614V50.4332C112.705 51.1139 112.326 51.7715 111.49 52.2534L83.1217 68.6423C82.2848 69.1271 81.1475 69.3455 79.9703 69.3161V35.3286Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M110.171 40.3611H112.657V50.4329C112.705 51.1135 112.326 51.7712 111.49 52.2531L110.171 53.0167V40.3611Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M82.6836 68.8567C81.1823 69.5 79.0107 69.4642 77.2545 68.7951V57.3568H82.6836V68.8567Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M83.1208 58.6043L111.489 42.2172C113.23 41.2107 113.011 39.4549 111.001 38.2916L83.6085 22.4677C81.5989 21.3062 78.558 21.1807 76.8166 22.1861L48.4486 38.5744C46.7072 39.5798 46.9267 41.3373 48.9363 42.4988L76.329 58.3228C78.3385 59.4831 81.3809 59.6099 83.1208 58.6043Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M48.9359 40.5709L76.3285 56.396C78.3381 57.5581 81.3804 57.683 83.1204 56.6776L111.488 40.2893C111.877 40.0652 112.162 39.8009 112.358 39.5165C112.956 40.4811 112.685 41.5263 111.488 42.2172L83.1204 58.6043C81.3804 59.6099 78.3381 59.4831 76.3285 58.3228L48.9359 42.4988C47.3742 41.5965 46.8983 40.3349 47.579 39.3455C47.853 39.7848 48.3053 40.2063 48.9359 40.5709Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M57.7157 52.7745C57.7157 53.5059 58.2284 54.3951 58.8604 54.7607C59.4939 55.1265 60.0066 54.8299 60.0066 54.0985C60.0066 53.3672 59.4939 52.4797 58.8604 52.1141C58.2284 51.7473 57.7157 52.045 57.7157 52.7745Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M54.0293 50.6439C54.0293 51.3764 54.5435 52.2655 55.1756 52.6295C55.8091 52.9951 56.3218 52.7002 56.3218 51.9695C56.3218 51.2381 55.8091 50.3479 55.1756 49.9823C54.5435 49.6165 54.0293 49.9125 54.0293 50.6439Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M50.3428 48.5159C50.3428 49.2466 50.857 50.1357 51.489 50.5013C52.1211 50.8671 52.6353 50.5705 52.6353 49.8391C52.6353 49.1084 52.1211 48.2193 51.489 47.8537C50.857 47.4879 50.3428 47.7845 50.3428 48.5159Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M81.4463 48.4464L94.7206 40.7778C95.5353 40.3073 95.4336 39.4844 94.4922 38.9409L81.6747 31.5359C80.7332 30.9917 79.3101 30.9329 78.4968 31.4046L65.2211 39.0732C64.4064 39.5438 64.508 40.3661 65.4495 40.9085L78.267 48.3135C79.2084 48.8576 80.6316 48.918 81.4463 48.4464Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M80.1709 42.0238L82.0066 40.9625L81.9757 40.7091L80.2033 39.6847L79.7628 39.6667L77.9256 40.7281L77.9565 40.9814L79.7304 42.0066L80.1709 42.0238Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M94.7206 40.7765L94.6823 40.7983L94.4922 40.6671L81.6747 33.261C80.7332 32.7168 79.3101 32.658 78.4968 33.1298L65.2579 40.7765C64.508 40.2398 64.4683 39.5067 65.2211 39.0719L78.4968 31.4033C79.3101 30.9316 80.7332 30.9904 81.6747 31.5345L94.4922 38.9395C95.4336 39.4831 95.5353 40.306 94.7206 40.7765Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M0.00971985 89.5581V79.7634L21.9586 79.7502L29.5446 75.369C31.286 74.3618 34.3268 74.4885 36.3364 75.6506L43.4155 79.7398L65.3836 79.7282V89.8C65.4322 90.4806 65.0535 91.1383 64.2167 91.6202L35.8487 108.009C34.1088 109.016 31.0664 108.889 29.0569 107.727L1.66421 91.9035C0.504738 91.2326 -0.0551071 90.3661 0.00971985 89.5581Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M32.6974 74.6956C33.9703 74.725 35.2918 75.0479 36.3364 75.6509L43.4155 79.7401L65.3836 79.7285V89.8003C65.4322 90.4809 65.0535 91.1386 64.2167 91.6205L35.8487 108.009C35.0119 108.494 33.8745 108.713 32.6974 108.683V74.6956Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M62.8981 79.7282H65.3836V89.8C65.4322 90.4806 65.0535 91.1382 64.2167 91.6202L62.8981 92.3838V79.7282Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M35.4106 108.224C33.9094 108.867 31.7377 108.831 29.9816 108.162V96.7239H35.4106V108.224Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M35.8478 97.9714L64.2158 81.5843C65.9573 80.5777 65.7377 78.822 63.7282 77.6587L36.3355 61.8348C34.326 60.6732 31.2851 60.5478 29.5437 61.5532L1.17567 77.9414C-0.565742 78.9468 -0.346214 80.7044 1.66334 81.8659L29.056 97.6898C31.0656 98.8502 34.1079 98.9769 35.8478 97.9714Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M1.66291 79.9379L29.0556 95.7631C31.0651 96.9252 34.1075 97.05 35.8474 96.0446L64.2154 79.6564C64.6044 79.4323 64.8887 79.168 65.0846 78.8836C65.6828 79.8482 65.4117 80.8934 64.2154 81.5843L35.8474 97.9714C34.1075 98.9769 31.0651 98.8502 29.0556 97.6898L1.66291 81.8659C0.101234 80.9635 -0.374634 79.7019 0.306023 78.7126C0.580055 79.1519 1.03235 79.5734 1.66291 79.9379Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M10.4427 92.1416C10.4427 92.873 10.9554 93.7622 11.5875 94.1278C12.221 94.4935 12.7336 94.1969 12.7336 93.4656C12.7336 92.7342 12.221 91.8468 11.5875 91.4812C10.9554 91.1144 10.4427 91.412 10.4427 92.1416Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M6.7564 90.0109C6.7564 90.7435 7.27058 91.6325 7.90261 91.9965C8.53612 92.3621 9.04883 92.0673 9.04883 91.3365C9.04883 90.6052 8.53612 89.7149 7.90261 89.3493C7.27058 88.9836 6.7564 89.2796 6.7564 90.0109Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M3.06987 87.8829C3.06987 88.6137 3.58405 89.5028 4.21609 89.8684C4.84813 90.2341 5.3623 89.9375 5.3623 89.2062C5.3623 88.4754 4.84813 87.5863 4.21609 87.2207C3.58405 86.855 3.06987 87.1516 3.06987 87.8829Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M34.1734 87.8135L47.4476 80.1449C48.2623 79.6743 48.1607 78.8515 47.2193 78.3079L34.4017 70.9029C33.4603 70.3588 32.0371 70.3 31.2239 70.7717L17.9481 78.4403C17.1334 78.9109 17.2351 79.7332 18.1765 80.2755L30.994 87.6805C31.9355 88.2246 33.3586 88.2851 34.1734 87.8135Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M32.8979 81.3909L34.7336 80.3296L34.7027 80.0762L32.9303 79.0518L32.4898 79.0338L30.6527 80.0952L30.6836 80.3485L32.4574 81.3736L32.8979 81.3909Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M47.4476 80.1436L47.4093 80.1654L47.2193 80.0342L34.4017 72.628C33.4603 72.0839 32.0371 72.0251 31.2239 72.4968L17.985 80.1436C17.2351 79.6068 17.1953 78.8737 17.9481 78.439L31.2239 70.7704C32.0371 70.2987 33.4603 70.3575 34.4017 70.9016L47.2193 78.3066C48.1607 78.8501 48.2623 79.673 47.4476 80.1436Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M0.00971985 77.5919V67.7972L21.9586 67.784L29.5446 63.4028C31.286 62.3957 34.3268 62.5223 36.3364 63.6844L43.4155 67.7736L65.3836 67.762V77.8338C65.4322 78.5144 65.0535 79.1721 64.2167 79.654L35.8487 96.0428C34.1088 97.0494 31.0664 96.9228 29.0569 95.7613L1.66421 79.9373C0.504738 79.2664 -0.0551071 78.3999 0.00971985 77.5919Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M32.6974 62.7294C33.9703 62.7588 35.2918 63.0818 36.3364 63.6847L43.4155 67.774L65.3836 67.7623V77.8341C65.4322 78.5147 65.0535 79.1724 64.2167 79.6543L35.8487 96.0432C35.0119 96.528 33.8745 96.7463 32.6974 96.717V62.7294Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M62.8981 67.762H65.3836V77.8338C65.4322 78.5144 65.0535 79.1721 64.2167 79.654L62.8981 80.4176V67.762Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M35.4106 96.2576C33.9094 96.9009 31.7377 96.8651 29.9816 96.1959V84.7577H35.4106V96.2576Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M35.8478 86.0052L64.2158 69.6181C65.9573 68.6115 65.7377 66.8558 63.7282 65.6925L36.3355 49.8686C34.326 48.7071 31.2851 48.5816 29.5437 49.587L1.17567 65.9753C-0.565742 66.9807 -0.346214 68.7382 1.66334 69.8997L29.056 85.7236C31.0656 86.884 34.1079 87.0108 35.8478 86.0052Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M1.66291 67.9718L29.0556 83.7969C31.0651 84.959 34.1075 85.0838 35.8474 84.0784L64.2154 67.6902C64.6044 67.4661 64.8887 67.2018 65.0846 66.9174C65.6828 67.882 65.4117 68.9272 64.2154 69.6181L35.8474 86.0052C34.1075 87.0108 31.0651 86.884 29.0556 85.7236L1.66291 69.8997C0.101234 68.9973 -0.374634 67.7357 0.306023 66.7464C0.580055 67.1857 1.03235 67.6072 1.66291 67.9718Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M10.4427 80.1754C10.4427 80.9068 10.9554 81.796 11.5875 82.1616C12.221 82.5273 12.7336 82.2307 12.7336 81.4994C12.7336 80.768 12.221 79.8806 11.5875 79.515C10.9554 79.1482 10.4427 79.4458 10.4427 80.1754Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M6.7564 78.0447C6.7564 78.7773 7.27058 79.6664 7.90261 80.0303C8.53612 80.3959 9.04883 80.1011 9.04883 79.3703C9.04883 78.639 8.53612 77.7487 7.90261 77.3831C7.27058 77.0174 6.7564 77.3134 6.7564 78.0447Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M3.06987 75.9168C3.06987 76.6475 3.58405 77.5366 4.21609 77.9022C4.84813 78.2679 5.3623 77.9713 5.3623 77.24C5.3623 76.5092 4.84813 75.6202 4.21609 75.2546C3.58405 74.8888 3.06987 75.1854 3.06987 75.9168Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M34.1734 75.8473L47.4476 68.1787C48.2623 67.7082 48.1607 66.8853 47.2193 66.3417L34.4017 58.9367C33.4603 58.3926 32.0371 58.3338 31.2239 58.8055L17.9481 66.4741C17.1334 66.9447 17.2351 67.767 18.1765 68.3093L30.994 75.7143C31.9355 76.2585 33.3586 76.3189 34.1734 75.8473Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M32.8979 69.4247L34.7336 68.3634L34.7027 68.11L32.9303 67.0856L32.4898 67.0676L30.6527 68.129L30.6836 68.3823L32.4574 69.4074L32.8979 69.4247Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M47.4476 68.1774L47.4093 68.1992L47.2193 68.068L34.4017 60.6618C33.4603 60.1177 32.0371 60.0589 31.2239 60.5306L17.985 68.1774C17.2351 67.6406 17.1953 66.9075 17.9481 66.4728L31.2239 58.8042C32.0371 58.3325 33.4603 58.3913 34.4017 58.9354L47.2193 66.3404C48.1607 66.8839 48.2623 67.7068 47.4476 68.1774Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M0.00971985 65.6263V55.8317L21.9586 55.8184L29.5446 51.4372C31.286 50.4301 34.3268 50.5567 36.3364 51.7188L43.4155 55.8081L65.3836 55.7964V65.8682C65.4322 66.5489 65.0535 67.2065 64.2167 67.6884L35.8487 84.0773C34.1088 85.0838 31.0664 84.9572 29.0569 83.7957L1.66421 67.9718C0.504738 67.3008 -0.0551071 66.4343 0.00971985 65.6263Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M32.6974 50.7639C33.9703 50.7932 35.2918 51.1162 36.3364 51.7191L43.4155 55.8084L65.3836 55.7967V65.8685C65.4322 66.5492 65.0535 67.2068 64.2167 67.6887L35.8487 84.0776C35.0119 84.5624 33.8745 84.7808 32.6974 84.7514V50.7639Z"
                    fill="#4067B1"
                  />
                  <path
                    d="M62.8981 55.7964H65.3836V65.8682C65.4322 66.5488 65.0535 67.2065 64.2167 67.6884L62.8981 68.452V55.7964Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M35.4104 84.292C33.9091 84.9353 31.7375 84.8995 29.9814 84.2304V72.7921H35.4104V84.292Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M35.8478 74.0396L64.2158 57.6525C65.9573 56.646 65.7377 54.8902 63.7282 53.7269L36.3355 37.903C34.326 36.7415 31.2851 36.616 29.5437 37.6214L1.17567 54.0097C-0.565742 55.0151 -0.346214 56.7726 1.66334 57.9341L29.056 73.7581C31.0656 74.9184 34.1079 75.0452 35.8478 74.0396Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M1.66291 56.0062L29.0556 71.8313C31.0651 72.9934 34.1075 73.1183 35.8474 72.1129L64.2154 55.7246C64.6044 55.5005 64.8887 55.2362 65.0846 54.9518C65.6828 55.9164 65.4117 56.9616 64.2154 57.6525L35.8474 74.0396C34.1075 75.0452 31.0651 74.9184 29.0556 73.7581L1.66291 57.9341C0.101234 57.0318 -0.374634 55.7702 0.306023 54.7808C0.580055 55.2201 1.03235 55.6416 1.66291 56.0062Z"
                    fill="#1681FC"
                  />
                  <path
                    d="M10.4427 68.2089C10.4427 68.9402 10.9554 69.8294 11.5875 70.195C12.221 70.5608 12.7336 70.2642 12.7336 69.5328C12.7336 68.8015 12.221 67.914 11.5875 67.5484C10.9554 67.1817 10.4427 67.4793 10.4427 68.2089Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M6.75664 66.0791C6.75664 66.8116 7.27082 67.7007 7.90286 68.0646C8.53637 68.4302 9.04907 68.1354 9.04907 67.4046C9.04907 66.6733 8.53637 65.783 7.90286 65.4174C7.27082 65.0517 6.75664 65.3477 6.75664 66.0791Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M3.06987 63.9512C3.06987 64.6819 3.58405 65.571 4.21609 65.9366C4.84813 66.3024 5.3623 66.0058 5.3623 65.2744C5.3623 64.5437 4.84813 63.6546 4.21609 63.289C3.58405 62.9232 3.06987 63.2198 3.06987 63.9512Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M34.1734 63.8809L47.4476 56.2123C48.2623 55.7417 48.1607 54.9188 47.2193 54.3753L34.4017 46.9703C33.4603 46.4262 32.0371 46.3674 31.2239 46.8391L17.9481 54.5077C17.1334 54.9782 17.2351 55.8006 18.1765 56.3429L30.994 63.7479C31.9355 64.292 33.3586 64.3525 34.1734 63.8809Z"
                    fill="#5F92D3"
                  />
                  <path
                    d="M32.8979 57.459L34.7336 56.3977L34.7027 56.1443L32.9303 55.1199L32.4898 55.1019L30.6527 56.1633L30.6836 56.4166L32.4574 57.4417L32.8979 57.459Z"
                    fill="#D9EFFB"
                  />
                  <path
                    d="M47.4476 56.2118L47.4093 56.2336L47.2193 56.1024L34.4017 48.6963C33.4603 48.1521 32.0371 48.0933 31.2239 48.5651L17.985 56.2118C17.2351 55.6751 17.1953 54.942 17.9481 54.5072L31.2239 46.8386C32.0371 46.3669 33.4603 46.4257 34.4017 46.9698L47.2193 54.3748C48.1607 54.9184 48.2623 55.7413 47.4476 56.2118Z"
                    fill="#4067B1"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="productSection pt-96 pb-128 flex-col align-center  justify-center"
      >
        <div className="grid flex-col gap-48">
          <SectionTitle
            title={'서버상품'}
            titleCaption={'PRODUCTS'}
            description={
              <>디엔에이클라우드에서 제공하는 저렴한 정품 상품을 이용해보세요</>
            }
          />

          <div className="productsWrap flex-col gap-64">
            <div className="productListWrap flex-col gap-40">
              <div className="flex-col gap-24">
                <div className="categoryTab flex-row gap-8">
                  <div
                    onClick={(e) => {
                      setActiveProductTab('all');
                    }}
                    className={`chipBtn flex-row justify-center align-center px-20 ${activeProductTab === 'all' ? 'active' : ''}`}
                  >
                    <span>전체</span>
                  </div>
                  <div
                    onClick={(e) => {
                      setActiveProductTab('dell');
                    }}
                    className={`chipBtn flex-row justify-center align-center px-20 ${activeProductTab === 'dell' ? 'active' : ''}`}
                  >
                    <span>Dell</span>
                  </div>
                  <div
                    onClick={(e) => {
                      setActiveProductTab('supermicro');
                    }}
                    className={`chipBtn flex-row justify-center align-center px-20 ${activeProductTab === 'supermicro' ? 'active' : ''}`}
                  >
                    <span>Supermicro 서버</span>
                  </div>
                </div>
                <div className="productsSwiperWrap">
                  <Swiper
                    onSwiper={(swiper) => (productSwiper.current = swiper)}
                    className={'productsSwiper'}
                    onSlideChange={(swiper) =>
                      setProductActiveIndex(swiper.realIndex)
                    }
                    slidesPerView={3}
                    slidesPerGroup={3}
                    touchReleaseOnEdges={false}
                    speed={500}
                    spaceBetween={16}
                    loop={false}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                      },
                      440: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                      },
                      960: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                      },
                    }}
                  >
                    {productData
                      .filter((item, i) =>
                        activeProductTab === 'all'
                          ? true
                          : item.cateCode === activeProductTab,
                      )
                      .map((item, i) => {
                        return (
                          <SwiperSlide>
                            <div className="productCard  flex-col gap-16 px-16 pt-20 pb-24">
                              <div
                                className={`categoryChip px-16  flex-col justify-center align-center ${item.cateCode === 'dell' ? 'dell' : 'dbGrade'}`}
                              >
                                <span>{item?.caption}</span>
                              </div>
                              <div className="infoWrap flex-col gap-32">
                                <div className="titleWrap">
                                  <span>{item?.name}</span>
                                </div>
                                <div className="detailInfoWrap flex-col gap-32">
                                  <div className="basicInfoWrap pt-20 flex-col gap-16">
                                    <div className="basicInfo gap-8 flex-row">
                                      <div className="label">
                                        <span>CPU</span>
                                      </div>
                                      <div className="info">
                                        <span>{item?.spec.cpu}</span>
                                      </div>
                                    </div>
                                    <div className="basicInfo gap-8 flex-row">
                                      <div className="label">
                                        <span>RAM</span>
                                      </div>
                                      <div className="info">
                                        <span>{item?.spec.ram}</span>
                                      </div>
                                    </div>
                                    <div className="basicInfo gap-8 flex-row">
                                      <div className="label">
                                        <span>DISK</span>
                                      </div>
                                      <div className="info">
                                        <span>{item?.spec.disk}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    // style={{
                                    //   opacity: item.cateCode !== 'dell' ? 0 : 1,
                                    // }}
                                    className="priceInfoWrap flex-col align-end"
                                  >
                                    <span>
                                      월 <strong>{item?.price}</strong> 원
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </SwiperSlide>
                        );
                      })}
                  </Swiper>
                </div>
              </div>
              <div className="indicaterGageWrap flex-col justify-center  ">
                <div className="gird flex-col">
                  <div
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                    className="gageRail"
                    onClick={handleClick} // 클릭 이벤트 추가
                  >
                    <div
                      style={{
                        maxWidth: progressPercent + '%',
                      }}
                      className="gage"
                    ></div>
                    {tooltipVisible && (
                      <div
                        className="tooltip"
                        style={{
                          left: `${tooltipPercent}%`,
                        }}
                      >
                        {Math.round(tooltipPercent)}%
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="moreProductBannerWrap py-40 flex-col gap-24 align-center justify-center">
              <div className="imgWrap flex-row align-center justify-center">
                <img src={productBanner} alt="" />
              </div>
              <div className="textWrap flex-col gap-16 align-center">
                <div className="title">
                  <span>더 다양한 상품을 만나보고 싶다면?</span>
                </div>
                <BlackArrowBtn to={'/contact'} text={'컨설팅 신청'} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="serviceSection  flex-col justify-center align-center"
      >
        <div className="grid flex-col gap-48">
          <div className="titleWrap flex-col gap-24">
            <div className="accent flex-row gap-8">
              <span>SERVICE</span>
            </div>
            <div className="title">
              <span>부가 서비스</span>
            </div>
            <div className="description">
              <span>최고의 사용경험을 위해 제공되는 부가 서비스입니다</span>
            </div>
          </div>
          <div className="contentWrap flex-row ">
            <div
              onMouseOver={() => {
                setPortfolioActiveIndex(1);
              }}
              className={`hoverCard flex-col pr-16 gap-16 ${portfolioActiveIndex === 1 ? 'active' : ''}`}
            >
              <div className="imgWrap">
                <div className="serviceTextWrap py-96  px-40 flex-col gap-16">
                  <div className="main">
                    <span>서버 초기화 & OS 재설치</span>
                  </div>
                  <div className="sub">
                    <span>
                      서버를 처음처럼, 깔끔하게 세팅해드립니다.
                      <br />
                      운영체제 변경, 설정 초기화, 파티션 정리 등 필요할 때
                      요청만 하면 바로 초기화 진행 가능합니다.
                    </span>
                  </div>
                </div>
                <div className="mainImgWrap">
                  <img src={portfolioImg1} alt="" />
                </div>
                <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                  <div className="textWrap">
                    <span>01</span>
                  </div>
                  <div className="arcSvg positionLB">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="arcSvg positionRT">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              onMouseOver={() => {
                setPortfolioActiveIndex(2);
              }}
              className={`hoverCard flex-col pr-16 gap-16 ${portfolioActiveIndex === 2 ? 'active' : ''}`}
            >
              <div className="imgWrap">
                <div className="serviceTextWrap py-96  px-40 flex-col gap-16">
                  <div className="main">
                    <span>하드웨어 교체 & 점검 요청</span>
                  </div>
                  <div className="sub">
                    <span>
                      장애 발생 시 빠른 하드웨어 대응 RAM, 디스크, 전원 등 장비
                      이상 시 즉시 점검 및 교체 처리로 운영 중단을 최소화합니다.
                    </span>
                  </div>
                </div>
                <div className="mainImgWrap">
                  <img src={portfolioImg2} alt="" />
                </div>
                <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                  <div className="textWrap">
                    <span>02</span>
                  </div>
                  <div className="arcSvg positionLB">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="arcSvg positionRT">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              onMouseOver={() => {
                setPortfolioActiveIndex(3);
              }}
              className={`hoverCard flex-col  gap-16 ${portfolioActiveIndex === 3 ? 'active' : ''}`}
            >
              <div className="imgWrap">
                <div className="serviceTextWrap py-96  px-40 flex-col gap-16">
                  <div className="main">
                    <span>리소스 사용량 확인 & 알림</span>
                  </div>
                  <div className="sub">
                    <span>
                      사용률 모니터링으로 장애 예방 CPU, 메모리, 디스크,
                      네트워크 사용량을 대시보드로 확인 + 임계치 초과 시 자동
                      알림 제공합니다.
                    </span>
                  </div>
                </div>
                <div className="mainImgWrap">
                  <img src={portfolioImg3} alt="" />
                </div>
                <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                  <div className="textWrap">
                    <span>03</span>
                  </div>
                  <div className="arcSvg positionLB">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="arcSvg positionRT">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="faqSection py-128 flex-col align-center justify-center"
      >
        <div className="grid flex-col gap-48">
          <SectionTitle
            title={'자주묻는질문'}
            titleCaption={'FAQ'}
            description={<>서버호스팅에 대해 좀 더 궁금하신가요?</>}
          />
          <div className="faqListWrap">
            {qnaData?.map((item, i) => {
              return (
                <div
                  onClick={() =>
                    setActiveFaqTab(activeFaqTab === i + 1 ? 0 : i + 1)
                  }
                  className="faqItem flex-col gap-8 py-24"
                >
                  <div className="faqQ px-16  flex-row gap-16 justify-between">
                    <div className="flex-col gap-16">
                      <div className="label">
                        <span>Q</span>
                      </div>
                      <div className="title">
                        <span>{item?.q}</span>
                      </div>
                    </div>
                    <div
                      className={`iconWrap flex-col justify-center align-center icon-24 ${activeFaqTab === i + 1 ? 'active' : ''}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="9"
                        viewBox="0 0 14 9"
                        fill="none"
                      >
                        <path
                          d="M1.08008 7.68677L7.01758 1.83495L12.9551 7.68677"
                          stroke="#555555"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    className={`faqA flex-col px-16 ${activeFaqTab === i + 1 ? 'active py-16' : ''}`}
                  >
                    <div className="content">
                      <span>{item?.a}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="ctaBanner pb-128 flex-col justify-center align-center"
      >
        <div className="grid py-40 tab:py-20 mob:py-32">
          <div className="bannerImage">
            <img src={bannerImg} alt="" />
          </div>
          <div className="titleWrap px-40 flex-col gap-48 tab:px-20 mob:px-16">
            <div className="flex-col gap-16">
              <div className="main">
                <span>최고의 파트너를 찾으시나요?</span>
              </div>
              <div className="description">
                <span>
                  디앤에이클라우드의 전문가들과 함께
                  <br />
                  최적의 인프라를 통해 비즈니스를 확장하세요
                </span>
              </div>
            </div>
            <Link to={'/contact'}>
              <div className="primaryBtn44">
                <span>문의하기</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HostingMain;
